import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "C:/Users/ruffa/Documents/GitHub/learninghub/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const FeatureCard = makeShortcode("FeatureCard");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <FeatureCard title="Low-code integration using AI - Demo Preparation" color="dark" mdxType="FeatureCard">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "35.06944444444445%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFwABAAMAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAED/9oADAMBAAIQAxAAAAHTQUnIJ//EABkQAAIDAQAAAAAAAAAAAAAAAAECAxIiMf/aAAgBAQABBQIMbS6Vu//EABYRAAMAAAAAAAAAAAAAAAAAAAEQEv/aAAgBAwEBPwGiv//EABURAQEAAAAAAAAAAAAAAAAAAAEQ/9oACAECAQE/AUn/xAAZEAEAAgMAAAAAAAAAAAAAAAABAAIQMVH/2gAIAQEABj8CbO4L3H//xAAYEAEBAQEBAAAAAAAAAAAAAAABEQBRIf/aAAgBAQABPyFikXN7KkDO4Ayb/9oADAMBAAIAAwAAABAAD//EABYRAQEBAAAAAAAAAAAAAAAAAAERAP/aAAgBAwEBPxAa3DS7/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPxBOQh//xAAaEAEAAgMBAAAAAAAAAAAAAAABABEhMUFh/9oACAEBAAE/ELjUq+MYhKcBG0e8iIojqf/Z')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "banner",
          "title": "banner",
          "src": "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/2e753/low-code-banner.jpg",
          "srcSet": ["/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/69549/low-code-banner.jpg 288w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/473e3/low-code-banner.jpg 576w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/2e753/low-code-banner.jpg 1152w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/74f4b/low-code-banner.jpg 1728w", "/learninghub/static/c4ee116bcdfb6cb41f399aec2ecd8b75/cbe2c/low-code-banner.jpg 2000w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </FeatureCard>
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">1 - Review Demo Scenario</AnchorLink>
  <AnchorLink mdxType="AnchorLink">2 - Provision a Red Hat OpenShift cluster</AnchorLink>
  <AnchorLink mdxType="AnchorLink">3 - Access your OpenShift cluster and install the command line</AnchorLink>
  <AnchorLink mdxType="AnchorLink">4 - Clone the demo assets from a GitHub repository</AnchorLink>
  <AnchorLink mdxType="AnchorLink">5 - Install the demo</AnchorLink>
  <AnchorLink mdxType="AnchorLink">6 - Set up Salesforce</AnchorLink>
  <AnchorLink mdxType="AnchorLink">7 - Set up Insightly</AnchorLink>
  <AnchorLink mdxType="AnchorLink">8 - Connect Cloud Pak for Integration instance to your endpoints</AnchorLink>
    </AnchorLinks>
    <hr></hr>
    <h3>{`1 - Review Demo Scenario`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`DEMO OVERVIEW`}</th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Scenario overview`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`In this demo, you are going to synchronize data between Salesforce and Insightly cloud CRM. You need to have these services and endpoints created and all the credentials necessary to access them securely in the demo. `}<br /><br />{`Both Salesforce and Insightly are CRM systems provided as a SaaS (i.e., they are hosted in the cloud). In this scenario, we will synchronize contact information data between both solutions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Demo products`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Cloud Pak for Integration`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Demo capabilities`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`APP Connect Designer: Low-code integration authoring; Mapping assistance`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Demo intro slides`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Download the Introduction and Overview slides `}<a href="./files/CustomerInteractionsSlides.pptx" target="_blank" rel="noreferrer">{`here`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Demo script`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A complete demo script is on the second tab above. The demo script has multiple tasks that each have multiple steps. In each step, you have the details about what you need to do (`}<strong parentName="td">{`Actions`}</strong>{`), what you can say while delivering this demo step (`}<strong parentName="td">{`Narration`}</strong>{`), and what diagrams and screenshots you will see.`}<br /><br />{` This demo script is a suggestion, and you are welcome to customize based on your sales opportunity. Most importantly, practice this demo in advance. If the demo seems easy for you to execute, the customer will focus on the content. If it seems difficult for you to execute, the customer will focus on your delivery.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Demo authors`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Rafael Osorio, Alan Glickenhouse and Callum Jackson based on Mapping Assist demo created by CP4I Dev team`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`How to get support`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contact `}<a href="mailto:rosorio@br.ibm.com"><a parentName="td" {...{
                "href": "mailto:rosorio@br.ibm.com"
              }}>{`rosorio@br.ibm.com`}</a></a>{` regarding issues with setting up and running this demo use case.`}</td>
        </tr>
      </tbody>
    </table>
    <hr></hr>
    <h3>{`2 - Provision a Red Hat OpenShift cluster`}</h3>
    <p>{`To provision your own Red Hat OpenShift cluster for the Cloud Pak for Integration, follow these steps: `}<br /></p>
    <p>{`2.1  To deploy a Red Hat OpenShift cluster, go `}<a href="https://techzone.ibm.com/my/reservations/create/63a3a25a3a4689001740dbb3" target="_blank" rel="noreferrer">{`here`}</a>{`. Select if you prefer to make a reservation now or schedule for later.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "46.875%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABJ0AAASdAHeZh94AAABp0lEQVQoz33QTUsbQRgH8IF4aCRlE9iSnHKqh9K7X8Bv4acI2PUghvUtKlWPXjwJeu+H8NJTTyHgEteS7CbtLrsxOxuTff07zwRDLNiBH/9hZnhmnmHVahX1eh2UqqqiVqtJqvoJiqKgXC4LFSgfP0ApMhRXGL5++YytbxoajYakaRq07W2cHB2CFQoFVCoVlEolkWWsrhYlxthbpXWsrF+CrZ1iY7MFJBxZBqRpiuXBjlrHaJ18x/HpmcymfoCdXR27zT3oug59T2RzBwcX1zi/+YX9q5+4/XGHLJkizXJZkCRJIpPR4vMswVTgzyn4JBJmiOJsfmWezyOdIZuNgPhJzKfI5VYuvXmh4zj4/WjCsvoYDGzYIn3fw3j8JIyXBBgHocDBebgo9i82Go3Q6/VEsQE8zwMPQ0wmE4Qi30P77w1GRfr9PmzbxnD4RxYlPvH9Oc9fzOkBVDSKoiWxFMcxGB2iF1qWBWrfdV24jjtPgdYIXUJtB0EALtgDB8aDha5pwTCHuDc9/HU8MM754p/o8P9afUXnDMNAu91Gp9PBQ7cL0zSlF6HnUCMks6RkAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image001",
          "title": "prep image001",
          "src": "/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/3cbba/prep-image001.png",
          "srcSet": ["/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/7fc1e/prep-image001.png 288w", "/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/a5df1/prep-image001.png 576w", "/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/3cbba/prep-image001.png 1152w", "/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/0b124/prep-image001.png 1728w", "/learninghub/static/d0f72eda64011335e8f1fca05d4034d6/14982/prep-image001.png 1901w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`2.2 If you do not have a sales opportunity, select the purpose `}<strong parentName="p">{`Practice / Self-Education`}</strong>{` (1) for a 2-day reservation (which can be extended without any approvals to 6 days) and fill in the `}<strong parentName="p">{`Purpose description`}</strong>{` (2).`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1130px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "60.76388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABJ0AAASdAHeZh94AAAB3klEQVQoz52S227aQBCG97WwApG4QULipfIoVe+aN6hSibuc1DRHciBSCCU2Dl7vwWsbE/N3ZjmkvUNd6dOs1zP/zOyO6HQ66PV66Ha7CIIA7XYbzb09tFotBI0GGkSwv4+Av5vNLY012zP+T4g4jhFFEZIkgZTS2w0yTTGjf5ODA0RnZ4hvbxFfXSG+vv4XOpsyl5cQRVFAqRRaa/C+LEvM53NPVVWol0vYiwtEJyeIJhOELy9IwhBqOoWmYhhHhWQU/9bvQ+R5DmstjDGeLMtIdI6SxYn5xwcWiwX03R1K8s05Mfkz5QaKq6gAeXoK4Zzz1XG7XqwowUk8LvcV1ySYDAaQNzdIyaYkLonNPnt68pj7+5WgUsqLrip0XpjhytnyWmK3JVgolas7VKny+5QehK0hQRb1yQjL1+ITU4xySFQBSRhtyEchI1/BQZIehTGWKizoTimTpb1zGbXuvOXqtQ9ciWttodZoY7YdCjWbIR6N6fVChK8x3p9fob58pbFxkKZCqktoW26v4RP7F5/nYvyjj+fzXxid/0Q4eMDo+xHevh1SS5TVZB5jM/Bd74J4Pz6GGtILDYcof4+RPz7if1dd1xCWeveDSVhqnwc0p0zFenR42HnAd4F9/wBF9Wd5gyLzFwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image002",
          "title": "prep image002",
          "src": "/learninghub/static/babcab0269693d04c41c9805b05990ad/41702/prep-image002.png",
          "srcSet": ["/learninghub/static/babcab0269693d04c41c9805b05990ad/7fc1e/prep-image002.png 288w", "/learninghub/static/babcab0269693d04c41c9805b05990ad/a5df1/prep-image002.png 576w", "/learninghub/static/babcab0269693d04c41c9805b05990ad/41702/prep-image002.png 1130w"],
          "sizes": "(max-width: 1130px) 100vw, 1130px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`2.3 Select the `}<strong parentName="p">{`Preferred Geography`}</strong>{`.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1125px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "32.63888888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABJ0AAASdAHeZh94AAAAyklEQVQoz63OTQuCQBAG4P1BflBePHnyp3cNsw4FpRfT3VXsYPm56dtugREIGTTwMDPwMgxxXReO48AwDNi2jeVyAcuyYJomNE2DrutjV5lvSBRFoJQiTdMR5xxJkiCO45dzDMoYsiz7yE0h1a2E6AT+UcMwgAxy6KX7BCEE+r6fRR3rug4kWa9BPQ9ss3mTO9/tkOcXFEXxE8KPJ7D9AZcwHOVBgGy1QnW9om1bNE0zS13X8uB2C+77YIr8Ts3q41SqyvIZmquU+QcMYOozWkbSPwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image003",
          "title": "prep image003",
          "src": "/learninghub/static/3769fa17253d02f097422a7cf0b1d1dd/55d53/prep-image003.png",
          "srcSet": ["/learninghub/static/3769fa17253d02f097422a7cf0b1d1dd/7fc1e/prep-image003.png 288w", "/learninghub/static/3769fa17253d02f097422a7cf0b1d1dd/a5df1/prep-image003.png 576w", "/learninghub/static/3769fa17253d02f097422a7cf0b1d1dd/55d53/prep-image003.png 1125w"],
          "sizes": "(max-width: 1125px) 100vw, 1125px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`2.4 Several additional fields will appear. Select `}<strong parentName="p">{`4.14`}</strong>{` (1) as the OpenShift version, `}<strong parentName="p">{`ODF - 2TB`}</strong>{` (2) for the storage, `}<strong parentName="p">{`16 vCPU x 64 GB - 100 GB ephemeral storage`}</strong>{` (3) as the worker node flavor, accept the terms and conditions (4) and click `}<strong parentName="p">{`Submit`}</strong>{`.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50.69444444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABJ0AAASdAHeZh94AAABx0lEQVQoz22SzUrrQBTH80K+iwuRa5tSq1BBUXF738CtzyBuXElVWo0oUr8/Fr0odCFIwbYZk9YkM5mkafP3zGBKvTrw48ycOd8zRnllBcvr61gol1FSLC1hvlRCfmoK5twczEIBpmn+oED6fD6PXC6HYrGofTbWVmE4j49wGg0EzaaGv7zAu7tDf2cHo8EAKYB0NEKapmNGdBZCaKIo0ug7sjXs21u8PzyA3d9r1N6+uMA7BeSuCyHl2DmDc64ZDoffkiiMt5MTdOt1uNfXcK6u4N7cgJGO7e0h9DxEcQxJQTNUNSpoTHq1JitXGG63C9Zuw7VteI4Dv9eDT5VJMpbkHIbhD1R1kwEnlxHQZb/fhyBDVU2GJH1W0f+EKiDJXyv0g0Bn1C2R0bg1VSE9iqREky2rs0gSDPD7MgKaEyeE7yP8QlACv1IBb7UgyXncLs1OjcI7O4NPc0/oXWMuMKC7RJKUIYzO6Sla1Sra9BBty9KSkY5tb4N3OogpYJS1To5qch9HR2hubqJxaOHf/jGeDiw81+p4PajRP6RHcRnTOMzWskcI9dcoCP8aiUbtkyGCy3Mc/93Cn1wNM7NVzfSshcWZXXwCYrPLXoFRxHgAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image004",
          "title": "prep image004",
          "src": "/learninghub/static/5781403d99863dc5137e6159428e7b18/3cbba/prep-image004.png",
          "srcSet": ["/learninghub/static/5781403d99863dc5137e6159428e7b18/7fc1e/prep-image004.png 288w", "/learninghub/static/5781403d99863dc5137e6159428e7b18/a5df1/prep-image004.png 576w", "/learninghub/static/5781403d99863dc5137e6159428e7b18/3cbba/prep-image004.png 1152w", "/learninghub/static/5781403d99863dc5137e6159428e7b18/3bd43/prep-image004.png 1322w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`2.5 You will receive a few emails as the provisioning process continues. You should expect the final email to be sent after an hour. The final email should look similar to the following.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.638888888888886%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABJ0AAASdAHeZh94AAACZ0lEQVQoz42Ty08TURSHZ2FICLTFailTJKJbNAYDaoBQaIuAujExxJ2oMXFl1J0LN8hK43/jwsSAIlWMIOGhyKO0hfLqY/qgz2mnfN4OpBpJxJt8+c259+TL3ORcaScYJqJED1AIRxRC4QixeIJ8oUDhCNR8iTx5kaV+KZZQCSfSRJM5ckVIqpBS9wRF9vi/VZLmcjlUVUVa9vpZ8a3hWQuw4l+nVK9t7rAVUtgMRtgM/UHwd26Im5UysBPCu76hE9gOIb0dHePdmJuR8c+MuCcEX5iYnmd2cZWZnx5mFj37KZhbWt2vBd89fp3JuR+Mf/2Ge3KaqfkFJHtnJz0ul06XvYOW5nNc73Nyo99Fr8tOX08X/Ve7udbrwGFv0/dKlPo6O67gdDrLOBzdSBUVFRiNJkxGAxVVFiTJjPXsZU6ebsHccJHaM5ewNLbS2NRVrk+IM0mq5Vi1DZPJiMFgKCOZzWZs9Q3IlmrkzmHkh1B7J4hlMELToygXnkQ5/1ih+alC+7Mo1rsKtYNh0Vfg1M03yFYzdbINWZZ1pJqaGmRbPceNlbTeeo17GSbmg3ycCfN+aosP09viO4R7Nox7LsKneYXx2RAzvgK3n49RVW0SojqsVquOLrQJYY0Qtg+8ZFeMzZ4aJZuKkUvHiCvbRILrJEQW8yk0NUk+m9DH5cHwCJVVJmx/C+UDYdvAK5YCafyri3h9PhLxOJlslsRuikwmx24yRU7Ns3cwoPeGRnWh/C/hQkBj2bOOfyNKLKmRzuTRtP1XoWmaoKhnad1/MXr0H3qDEAyFyYirZwUF7fDLKAuHDgt/AVuGok3TjedDAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image005",
          "title": "prep image005",
          "src": "/learninghub/static/e18c8cf1c01b983beb78efb9a2ddb7bf/3cbba/prep-image005.png",
          "srcSet": ["/learninghub/static/e18c8cf1c01b983beb78efb9a2ddb7bf/7fc1e/prep-image005.png 288w", "/learninghub/static/e18c8cf1c01b983beb78efb9a2ddb7bf/a5df1/prep-image005.png 576w", "/learninghub/static/e18c8cf1c01b983beb78efb9a2ddb7bf/3cbba/prep-image005.png 1152w", "/learninghub/static/e18c8cf1c01b983beb78efb9a2ddb7bf/c170d/prep-image005.png 1273w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <hr></hr>
    <h3>{`3 - Access your OpenShift cluster and install the command line`}</h3>
    <p>{`In this section, you access your OpenShift cluster and install the OpenShift command line tool.`}</p>
    <p>{`3.1 Open the `}<strong parentName="p">{`Reservation ID`}</strong>{` link that was included in the “Reservation Ready on IBM Technology Zone” email.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1117px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.94444444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABJ0AAASdAHeZh94AAACbElEQVQoz42T3UuTURzHHyJvym2azr04IzKjoiIqEqTUHGxtlmsX0UVQYBESXUR5URdBl913378QBCVCmb2Aijk1tfky29bUbc/jXp170cd9OmwSBAod+PD7nh+/8+FcnCMl5SyJtQ2UVI50TiW7Cal8kTVBdmOL/1mFTZV8vkC+UECKRGMsBoL8CvwmEFomuFRGjsVREknk+G4kxEyZlahCaCXCUkRGmv0V4MPXIb6MfC/xebjMuHeBqYUAU/N+UctMi/20L1DKM4tBvP4l0fMzMjHF0NgknplZpN7eXjqsVpxOZwlrRxvtrS3cvOHmepcTt6uTrqtXcF1z0umw4bBbS33r5UtcbGkWZxzYbDbsdnupSg6Hg4qKCnQ6HVUCaa9A0mFuPI/WcAzDoTPUWk5iOnyWg0cvUFnbJPI59uy3iDkNB2r0aDUatFptCcntdlNdXY3ZXI/JqMfs7sfyEOq6EzT0ZDj1eI3TT8q1+VmGE48y6LvTWHqymO+v03C8DaO+GpPJjNFoRHK5XKXb1ZtNVGpruPNiEF8ExmdXGfOu4plVRFZElplciPPDl8Azl8AXSvJ6YANDUzuGWi0Gg1Fg+Fe4T1PDg5cDqEWVZFIhFouSSseJRJaQ5WVSCYVCNk06GYdiivdjOeqOtJWFxh2ElTo9956/w/9zjpnRUQJeL4mVMHHxjJKRKJn1LJnMOur28+ybKKJvbBVC3Q5Ck5HKGhO3b71ivn8Iz9sB5j+OEPzmQRkeIT74CVVItlSVzW1j3/gW+tINdxKahbBKz92nb/BPTBOaniEflcmGI+TCYZGjf3+GqhZ3Ff4BHjVUGbwuwN0AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image101",
          "title": "prep image101",
          "src": "/learninghub/static/9e75ae16591c906a0abe3f5ba8c1baa6/6af85/prep-image101.png",
          "srcSet": ["/learninghub/static/9e75ae16591c906a0abe3f5ba8c1baa6/7fc1e/prep-image101.png 288w", "/learninghub/static/9e75ae16591c906a0abe3f5ba8c1baa6/a5df1/prep-image101.png 576w", "/learninghub/static/9e75ae16591c906a0abe3f5ba8c1baa6/6af85/prep-image101.png 1117w"],
          "sizes": "(max-width: 1117px) 100vw, 1117px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.2 Copy the kubeadmin `}<strong parentName="p">{`Password`}</strong>{` (1) and open the OpenShift console by clicking on `}<strong parentName="p">{`Open your IBM Cloud environment`}</strong>{` (2).`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1120px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABJ0AAASdAHeZh94AAAC3ElEQVQoz22QWWhTaRTH7+M8yIDYbE2bmGbR2Ca22rSpbUdxKwjqgzixVotFwY4KMgx2GHCmNq1drDvok4Ki4LuiIOiAWtzQqqiFjvOSNGmuN4lJ7k3SKja/+bz1cQ78v7P/z/mO5HG78ft9eDweLBYzi+12zGYTFVYrJqMRo8GA0WjAYCgTMMz7ul2mx80mAybDIuHP10qVFeU4nQ5slVY87iqs5YLUViH8cj222GbVY3Z7pRhm03PfYi6HTa9xGBdQvuhHPHYLXocFqSFQT8fOdsxiWkNgJauCDbSsChJsDNDc1Ehrc5C6Wh9NwQCB+jr8vmpql/v4qbUFn8uKbeEP1DitNHoFqu1IK1auINQeosZfw/oN69m6ZTPfhqxuaaapoV40NrNxwzqW+5bhdjlY4nHhdjt17bWb8LpstPgdrKmrYl1gqfiyuFnrz220HdjG2p2b6Noe4lBHJx2hEJ3d++nq3M2+vV2079hOrb8a71KPfgpbhUXcsAxnpZGAcyGty4zUVpUh9R/tYeSvXzkZ7uHswO+c6zvChdFeTnXv5XjbRk6cOc3JkWFGhgcZGggz2H+M/r7eeYT7GD4e5tzQn1wcPcbowFGk65desatngsNDUQ4OJujqjbO7P8nf52/x9d4dSgiZmxOPbv2vlL7OMfc9Ld24Ms6RkQ/8JvBL3yTd4Un2/DHB3TsT5Esl5I9ZlJSKklZJZjRS35HOauRUDbVQQBVEqqqSy2WRsuk02cQUOTnG7CeF2UySzxmFlCCJJTRiH/PElQJxWSUeTRMTiEZSQqf4lBS9kQjpy5dRUynyglxKyDLxhExWTNMKRfLFGYEiM8U8szMas0WNL1+KZF88I3LvLvLjhySfjqEIpF8+R759E/naVdRMZp5wenqaSDSKoiRJJlO6joltookCUTkvdJ4ppci/4x8Yv/+C1w9e8/bRG96NvWHy2Xv+efKOqVyJnCaWyWv8B/7MMkr0Pv/nAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image102",
          "title": "prep image102",
          "src": "/learninghub/static/d8fbd2b3afadc13064d3afaa8eba9311/a7549/prep-image102.png",
          "srcSet": ["/learninghub/static/d8fbd2b3afadc13064d3afaa8eba9311/7fc1e/prep-image102.png 288w", "/learninghub/static/d8fbd2b3afadc13064d3afaa8eba9311/a5df1/prep-image102.png 576w", "/learninghub/static/d8fbd2b3afadc13064d3afaa8eba9311/a7549/prep-image102.png 1120w"],
          "sizes": "(max-width: 1120px) 100vw, 1120px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.3 Use `}<strong parentName="p">{`kubeadmin`}</strong>{` (1) as the user, paste the `}<strong parentName="p">{`Password`}</strong>{` (2) and click `}<strong parentName="p">{`Login`}</strong>{` (3).`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "45.138888888888886%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAABJ0AAASdAHeZh94AAACJklEQVQoz1WSTW8SURSGh6+hQCuEb0PtX+iyxmX/gJumLg1+1HQj3QBNQ0NCYmhC04WJP6ELrVTT6MIWoUWlRo2SmGpsYVEpJTDjEOgUBtC+nrlgG2/yZu69mfvkvO85nNfrBc/zCAaD6CgKKpUKhFqtL0FArVqF1GigThLp3Ol0cHdmBhzHQaPXsy+TRgOtTgdOBRoMBkSjUair3mjilMBNWYbcauOk3cYZwUB3/9a9QABWgkx5PLg2OYmrExPgjUZotNoL4GIkAtBD6WAfSrkM5egISqkEpV6HlEhATqfxewC8PzfHqnKbzbjs88E3Ogrj0BCrsg8keoQsK4UCyqRTstsWRSZZtZzPo9vtotfrMWA4FAZPALvbDbPFAhOBL1mtMPCGAZAyXFxYgJzLoZhch5jOQNrehrSzA2FzEyd7ewzUHdieD4dhIdDY2BV4yLbdbsfwyAjjnAMj9FOvWMCv4gFax2X0hCr+iAK6kojW6xRQOjzPMBAKQUd5qW9dLheT0+mEw+G4yDBCGbZ+HuNH9gMKu5/7evcJxfx3fE08xLeVRzisNdH++AUr4+Msw2Gq0mazwUEwFeqmCBhQq9NjOR5DJrWPqfkt3H7wBjdjWcwuvcVsnPbxXdxaymE69AqZtfeI3fEzoJ7GRu2sngpSm6LmyakZmEwm+P1+ZFNpbDxJ4kXy+X96+fQZNtbWkVx9jPRWCtdvTPeBBFJnT4WykaEu/wVnCLpC9u2QMAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image103",
          "title": "prep image103",
          "src": "/learninghub/static/443808d34b671d1fae7d13cdb4351551/3cbba/prep-image103.png",
          "srcSet": ["/learninghub/static/443808d34b671d1fae7d13cdb4351551/7fc1e/prep-image103.png 288w", "/learninghub/static/443808d34b671d1fae7d13cdb4351551/a5df1/prep-image103.png 576w", "/learninghub/static/443808d34b671d1fae7d13cdb4351551/3cbba/prep-image103.png 1152w", "/learninghub/static/443808d34b671d1fae7d13cdb4351551/a7a9e/prep-image103.png 1393w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.4 On the web console page, click `}<strong parentName="p">{`?`}</strong>{` (1), and select `}<strong parentName="p">{`Command line tools`}</strong>{` (2).`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.45833333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABJ0AAASdAHeZh94AAABnUlEQVQoz2WR205TQRSG91sY03jCA9BKA91VqYXWlkjijTeGZwC90RfwDXwNL3wUTUxISRQkQRAD0bbb7tPM7OPnmi3hxp18mTXZ/6z1/zPOjVqNlXqdhXqDW3NzdDod2u02ruv+R0t4sbXF9s4O2y9f8fbNa95tPuP5Wo/ecMhjOevM15eYbzS5eu0mS8suo9Eep6c/mEwmxHFMFEWXxP6MeDpF/fGgLLBfaDRBGFba2WyG4652WXYfVk27vQGHRyeYHPI8pygKiovV7v33H/j16SM/R7uc734mODmmLKk0tkjTFGd1fUC3P6DZekB/Y5P9g28oZTAy2SQJiYgSuwqxOPCtG61JpYklMQYthLHB9/1/ke8sNC4jfz3YRyeawo7OUqIgkoMlWZ6iskyiKYIgqOJWCYRKKhqlFM7dxfvcvrfIldp16s2WOPwi8TSx0iQiMNIgzcRNJg6tkzCqnNgryGSApShKkqxAiXOnP3xKZ/0JK+1HbMiLHX8/Ik8NZ2fn/B6P8TyveiCL502ZXtRj+WexdWYHikOtDX8BrSG5H2Qz70cAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image104",
          "title": "prep image104",
          "src": "/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/3cbba/prep-image104.png",
          "srcSet": ["/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/7fc1e/prep-image104.png 288w", "/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/a5df1/prep-image104.png 576w", "/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/3cbba/prep-image104.png 1152w", "/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/0b124/prep-image104.png 1728w", "/learninghub/static/9c878465dd287480b7fb5cce6e4d4885/bf99d/prep-image104.png 2147w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.5 Follow the links to install the OpenShift Command Line Interface (CLI) for your Operating System.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "51.041666666666664%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABJ0AAASdAHeZh94AAABoklEQVQoz52Se0/bMBTF8z0ArQwGbdLSsqyorz/67YFNIEQHKpBmPNOS5kHnhDyds2tXgAB1Qlj66TrO9fHxvVa+LC2hXi6jomkolVbRarXQbDah6/pCOp0Out0uer0e2u02+v2+RKwr5WodlVoDK6vrULe2cXB4iLFlwTRNieu6CMMQjDEEQfAaFrxbUzQS+VbRsEyCYn5hjCBGnBX4zFBUciccLpfWZByenSNKMjieTyeG0p04WTjknC8UEscXRUFX1rawoValoFr/juO9PdjGGa5/H+PmdEBxgEviirBHxgumgak5wuz2Bsy6I26RB2xew021NhekK5/s78MPcky8R1huBJ/FKHiOLMuQJgmSOEYi4pt5SnPue1BqDZ0czgVr2z9w8vMXrr0cxn2E4TjClRPDC3PwD9SPzx6gNPQd6exZcHcX07GHqWXDtx3Mpg4Cx0VCyenf2UKSBx+ZcCg6u/nsUMfg6AjMnmBy+Qeh58jkmMQi2vA/RA6nssguf92oyHdYpaYMzy8Q0/3YI9WHEp5Is5x4+U7S9NV/Xsyf2T8Mk32LkXYURAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image105",
          "title": "prep image105",
          "src": "/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/3cbba/prep-image105.png",
          "srcSet": ["/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/7fc1e/prep-image105.png 288w", "/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/a5df1/prep-image105.png 576w", "/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/3cbba/prep-image105.png 1152w", "/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/0b124/prep-image105.png 1728w", "/learninghub/static/9dd4c7463b639b60a767efdbd1997d6f/bf99d/prep-image105.png 2147w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.6 To configure the command line on your machine, click on the down arrow to the right of kubeadmin (1) and select `}<strong parentName="p">{`Copy login command`}</strong>{`.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1127px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "27.083333333333332%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABJ0AAASdAHeZh94AAABM0lEQVQY04XOzUoCURTA8XmFmqIP1MaUhFEx00ZNDNpoEEkgrVz1gS2sXRRtoghaRIRCtJCgNkKvEq3qNYLUnEbvzNS/665o0YUf55x7zzlcJRGPUzAMCvk8qVSKOVkHp/1oPi/alE/y/ibvA36NeDSMFo2wp+tcSJVslkpYRxlWRxmf9DDh8aGqKul8ieROA718ibFVJ7FRI7lZY14a5IOY2a6xWL0hVjymWtrl8bbBy/0dzaNzlOJ6mdW1EssrRYyFHFf1a8QXvHZ6/Hesp2fazQd6HyZup40wLZR0bgkjk2U2YRAMhTk5PUO4stmycB2BYwts0f+r38P+dBFysXAcbNelLwRKSI+gR2JogRmGRsbYPzjElT98a7Xodru8S0I22oMh25acH2Q9eJPRkUzT5Bt6URKuDrNgqAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image106 1",
          "title": "prep image106 1",
          "src": "/learninghub/static/b7e8f8e154c9f21b76d38b74666cb762/5605e/prep-image106-1.png",
          "srcSet": ["/learninghub/static/b7e8f8e154c9f21b76d38b74666cb762/7fc1e/prep-image106-1.png 288w", "/learninghub/static/b7e8f8e154c9f21b76d38b74666cb762/a5df1/prep-image106-1.png 576w", "/learninghub/static/b7e8f8e154c9f21b76d38b74666cb762/5605e/prep-image106-1.png 1127w"],
          "sizes": "(max-width: 1127px) 100vw, 1127px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`3.7 Click on `}<strong parentName="p">{`Display token`}</strong>{`.`}</p>
    <p>{`3.8 Copy the `}<strong parentName="p">{`Login with this token`}</strong>{` and run in the command line.`}</p>
    <undefined><br></br><span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "29.166666666666668%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABJ0AAASdAHeZh94AAAA7UlEQVQY033R7U6DMBQGYO7/Sowx6gSJd6JxyMqmVLBQaMtH4cfracdwRrMfT3rO2+Y0aYOiLMGyDK1S6PoepuugjVlXO02XjSOstaug5BzvjCHf76Gl9JSs13rQGgMN/sPldOlIA88F6SbE89U1Xm5ukdyH2IUxefSyKAaLjn36EHmudll6t8EhfoI0PWSriPaCA8vwtk2wfU2wSxn4B0e+4Cf55+9s6QterIOcRtFAZQaIpkOtOkhlIKTCFxGN8rVbazpcNdrnTrX0wmV1Q1oIUtPZoBIWqqUHHS2m6Wiefupz8z97M33MyUS+ASl6whW5qg03AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image106 2",
          "title": "prep image106 2",
          "src": "/learninghub/static/e08074f05bebfce935197738551c17db/3cbba/prep-image106-2.png",
          "srcSet": ["/learninghub/static/e08074f05bebfce935197738551c17db/7fc1e/prep-image106-2.png 288w", "/learninghub/static/e08074f05bebfce935197738551c17db/a5df1/prep-image106-2.png 576w", "/learninghub/static/e08074f05bebfce935197738551c17db/3cbba/prep-image106-2.png 1152w", "/learninghub/static/e08074f05bebfce935197738551c17db/b860f/prep-image106-2.png 1407w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
      <br></br></undefined>
    <p>{`You have successfully configured the Openshift command line on your machine.`}</p>
    <br />
    <hr></hr>
    <h3>{`4 - Clone the demo assets from a GitHub repository`}</h3>
    <p>{`To copy the repository you will need to have the Git CLI on your machine. If you don’t have it, follow the installation steps described in this `}<a href="https://github.com/git-guides/install-git" target="_blank" rel="noreferrer">{`page`}</a>{`, based on your operating system.`}</p>
    <p>{`4.1 To download the scripts to install the demo, create a new directory, change to this newly created directory, and run the following command:`}</p>
    <pre><code parentName="pre" {...{}}>{`git clone https://github.com/ibm-integration/code-low-code-integration.git
`}</code></pre>
   <br />
    <p>{`4.2 Change to the new `}<strong parentName="p">{`platinum-demo-code-api-enabled-integration`}</strong>{` directory:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd code-low-code-integration
`}</code></pre>
   <br />
    <hr></hr>
    <h3>{`5 - Install the demo`}</h3>
    <p>{`5.1 To deploy the demo run:`}</p>
    <pre><code parentName="pre" {...{}}>{`./deploy.sh
`}</code></pre>
    <p>{`   This will automatically deploy the resources into the CP4I namespace.`}</p>
    <p>{`5.2 The deployment will take approximately 30-60 minutes to install. The URL and credentials will be shown once the installation is complete.`}</p>
    <span {...{
      "className": "gatsby-resp-image-wrapper",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "maxWidth": "1152px"
      }
    }}>{`
      `}<span parentName="span" {...{
        "className": "gatsby-resp-image-background-image",
        "style": {
          "paddingBottom": "38.541666666666664%",
          "position": "relative",
          "bottom": "0",
          "left": "0",
          "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAAAsTAAALEwEAmpwYAAABcUlEQVQoz2VRa0/CQBDsNx881QiiJjwr0EI5aKHQAsXyKiiI0fj//8m4u7XRxA+T2dvbnZvd02ZFB6vaBGHZRVhxsdGnCB4dTEt9DPMG1GUD/bQukDil/yIdc++ijkH6CSrVgPZqhoiacxw6IWGJF+NZztHTDFsS37cCyR27S5zUBkdrhR3ldlSzby+kjnlVHcPONqFtGr64Y5dcyAJbKlrXPSyrExFNwI0sxHfrmic5jlkjeLDhZFvQ3uhFfvXDjqRheqdgZ5oyBo/I4Jhhndf+5ZOYe3hscRi/HshrvD92zLHstTyi2MeyMhYnkTj040l+HPpFBa9gwb02Y0EuSMRm9wPMyT6LbXUane55FZznTxrfdDC6MqV5mG8LBuQu+Rzt1Fvjyz3g09njXW1lyYwFifNeeAXCxZ6IebcWOephQsxnZs4xy8hWsQ1VMGKUTCgqsnJddDImjFQLZqodc9qASTmVM8hNA92zquz0L9jhN/ee9bKGqNLMAAAAAElFTkSuQmCC')",
          "backgroundSize": "cover",
          "display": "block"
        }
      }}></span>{`
  `}<img parentName="span" {...{
        "className": "gatsby-resp-image-image",
        "alt": "prep urls",
        "title": "prep urls",
        "src": "/learninghub/static/b0e503b18a183d18ee80868b07737b85/3cbba/prep-urls.png",
        "srcSet": ["/learninghub/static/b0e503b18a183d18ee80868b07737b85/7fc1e/prep-urls.png 288w", "/learninghub/static/b0e503b18a183d18ee80868b07737b85/a5df1/prep-urls.png 576w", "/learninghub/static/b0e503b18a183d18ee80868b07737b85/3cbba/prep-urls.png 1152w", "/learninghub/static/b0e503b18a183d18ee80868b07737b85/0b124/prep-urls.png 1728w", "/learninghub/static/b0e503b18a183d18ee80868b07737b85/65d9c/prep-urls.png 1836w"],
        "sizes": "(max-width: 1152px) 100vw, 1152px",
        "style": {
          "width": "100%",
          "height": "100%",
          "margin": "0",
          "verticalAlign": "middle",
          "position": "absolute",
          "top": "0",
          "left": "0"
        },
        "loading": "lazy"
      }}></img>{`
    `}</span>
    <p>{`Your have installed the Cloud Pak for Integration ready to be configured.`}</p>
    <br />
    <hr></hr>
    <h3>{`6 - Set up Salesforce`}</h3>
    <p>{`You need a Salesforce developer account to run this demo. If you already have a Salesforce developer account, you can use that (start at step 2 below). If not, you can sign up for a free developer account by following step 1 below.`}</p>
    <p>{`6.1 Go to `}<a href="https://developer.salesforce.com/signup" target="_blank" rel="noreferrer">{`Salesforce Developers`}</a>{`. Follow the prompts on the Saleforce pages to get your free developer account.`}<br /></p>
    <p>{`6.2 As soon as you have your account, go back to the `}<a href="https://login.salesforce.com/" target="_blank" rel="noreferrer">{`Salesforce log in page`}</a>{` and log in to your developer account.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "57.98611111111111%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAACi0lEQVQoz3WT227UVhSG50F4gj5JnwTxCr2BCySkgGiDqHrB4TISF6ipyik00BIUgoAhTUIyB4bMZJgknhk7dry97e3Dtj+WZ4JEVWHp1/697PX7Xwc34jglSTLqMzUZmZnzr7HZmaScnGpCnRBGCacqnp01VB3T81heWBrxWaIRnCjDSWhmPNZmHjc5Qahp7x8x9UMCSazFa0x9hRuoGXeFp1khgnWSEJNbfnw+5YcHY5quobIlOq4/lsmLGX7g43oeWmtsUfC9q5GIAzVyiD4OuPNPl9t/dxh3Doh6A2Ipqa4gLzKM9on8Kb434dhxmEwmKKUoRLyqwJYVpZBGEhn81i7O5x1KvwvRPqkeoNrvibyQTNyPfc3Si4/cWdljY++QNImltwZrLWVZ/tehDsVFvyO0JxgIDgQjcHZQIlj3xZO+vvwwZvndEd3j6H9lBnnFu5OCz0oc5jKh7mabKystFv5qc/1Zh0srHR6uNslDhUpySSlZOsz5fWTIs5xplDFVKa5gquZ9XtjTnF/PaBilOWr1edyJeb6fsT4sWB3C7taQxD+lEIe9IOfco5Rraw6Xn4y4+dKh5yh6k5juOObI0yz3DRff2vmUw06X+FOPbNinGg0wwwPU9jZKVqESR38MSi7cu4s/fI0r5bsHfeLj4VnBMhEsba/k+vvqbA+jGH/s4R7LFKcBgRugZb/qtbEm5U9p7eLqBs7hLrncZ2ky+wlyW5FaZNKW5rjkarOcO6z/hiQtZvuYpPkcsk61YJGmPO1bFnfgRT/i9SePBxtb9A9d1l6tcePhBvdbhlvbOT9vVnPB7+FbwYWm5ZdNy9U3hp+W/2Vp65Tf1ltcfvqBX7dKFjfr5xVfAEfUex8Vc+WfAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 5",
          "title": "Prep3 5",
          "src": "/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/3cbba/Prep3.5.png",
          "srcSet": ["/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/7fc1e/Prep3.5.png 288w", "/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/a5df1/Prep3.5.png 576w", "/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/3cbba/Prep3.5.png 1152w", "/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/0b124/Prep3.5.png 1728w", "/learninghub/static/7f2c0d067f8b6b802b96b722d612ae8a/7d88d/Prep3.5.png 2160w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.3 Click the `}<strong parentName="p">{`profile`}</strong>{` icon (1) and save your Salesforce Login URL (2).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.45833333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABx0lEQVQoz02R22sTURDG98/0zTd98ME3QRBEpYiCiiAUbNV6JVhv1BAjkQZDsQYaatO0aW7d7G66ye5JNrtns7lsLj9Pgw8e+Jhv5sx8c+aMtmuHmF5IX0b0ggHCj3CDEWddSUv4dPoDheif/Q8qT/oSaVkMg4AolaJx4yZaGCoRz2c0mZDdr/E0mafcsGhYgprhUFWomc6Sn9uKKThpOhhOgFWuU/qSxMjtYL19Q+XyFbSO6NJ2BNN4wu5xi9VUgW0lvFWokT7Q+VG0SO83yRyayjdU0xNypTqbO38QXcFY1U0XC2aLOaffs2h9z8NXT17MY450j5epDyQLOTJlg8efEjx8d5u1bwmurd/j+voKr1cv8fnZRS7cvcqxrhONYjVdrOpneFPQXNdFCMEsHlM1PRLpJL/ym5hHP/mdfkV2e4NS8SNbXx9wf+0Wj57f4cmLFTYy72m6HrYIED2P8Vj9uxug+b5PICXnp9hwsMSIhRJ3VKNoMEA1ZjZfXhOoJcTjeMnVlIS+R6dtY5+1iEcR+YpAk0osiqJl0uGpy15VqC0OqbdDDFfBkVRbfSxXqpik2QnQ2/4yZveGNDohuhMqHpE9sPkL1cTztM5Y+AAAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 6",
          "title": "Prep3 6",
          "src": "/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/3cbba/Prep3.6.png",
          "srcSet": ["/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/7fc1e/Prep3.6.png 288w", "/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/a5df1/Prep3.6.png 576w", "/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/3cbba/Prep3.6.png 1152w", "/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/0b124/Prep3.6.png 1728w", "/learninghub/static/4a5b887c995fd67a68ba7d53f6a37d7b/a825a/Prep3.6.png 2172w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.4 In the same user profile menu select `}<strong parentName="p">{`Settings`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.80555555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABYlAAAWJQFJUiTwAAABvUlEQVQoz02Ry2/TYBDE/Wdy48SZExduPAQIJOCABFJaEYREoSqIHNqgCBFVFJXyaEPbkIak1IkdO47tz/Ezduz0xxfDgZFGu9o57OyO8skIGXkRIohx/ZDJNGbizxg5AZo9xZTa/xwLSe8vwzglSmYkScJ8nuF6AUoYhthiSpplNL52qWzucfJb51Sz6Q0tfg2ssvb+1e7Q5kS1UC0frdOn2/iAJ41kWYolQhRz4rBkLjd8PBryZOs7zVaf2rce736c8f5Qo36g0pBavaXS3O+wfdRnfafFeKQRmQZ5nrMoCgzbRxFC4PsBLOYcnjo821pnc3+Hxs8BD1+/4MHaDSr1l1xZucPVlVs8f3yJN6sXuXD7Mm11QJKfM8tyzhcFjnyXYlkWtuNQ5Bkd1WGtXuPzlw2G7W1261WazSrHhxu8rd3jbuUa91ev8+jpTaqNV6gTUbqyXUGWphhOhOJ5HkEQssRBb4zuzCjSBHNssfyvvIZ5Ucp4wiedZWW/WIDvuRjGCF3XSZOIva6NEgQBsUxpieMzm/ZAMI0yNCeWSSZYXszACsr0denAlCmbbljO3CBFd+VykSDClN2OxR/p0/iMyf5ugQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 7",
          "title": "Prep3 7",
          "src": "/learninghub/static/01f472ff791845b2260e90096ab69113/3cbba/Prep3.7.png",
          "srcSet": ["/learninghub/static/01f472ff791845b2260e90096ab69113/7fc1e/Prep3.7.png 288w", "/learninghub/static/01f472ff791845b2260e90096ab69113/a5df1/Prep3.7.png 576w", "/learninghub/static/01f472ff791845b2260e90096ab69113/3cbba/Prep3.7.png 1152w", "/learninghub/static/01f472ff791845b2260e90096ab69113/0b124/Prep3.7.png 1728w", "/learninghub/static/01f472ff791845b2260e90096ab69113/bdc8f/Prep3.7.png 2164w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.5 Click `}<strong parentName="p">{`Reset My Security Token`}</strong>{` in the `}<strong parentName="p">{`My Personal Information`}</strong>{` (1) menu. Then, click `}<strong parentName="p">{`Reset Security Token`}</strong>{` (2). A newly-generated security token will be emailed to you.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "42.01388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABYElEQVQoz43Pa0vjQBSH8Xx/hIVF/AyLaIsKoigUROsb77ZNa5ukTdr0YtJOmpi0muTZUy+luwp64Jc5Q2b+M6MVyg8UzupsnTX4U6qweVLj8NJaOni32h/8///C4ui6TaHcRLs3BvSGPipMKOs9fhXPuaw0uRBXNQPdckV/ZfysZrqY3SHF0zqaCmPU2GcWR0ymCXqriymbO85Q5nM5aIXMJ8HsE18M/Sd0cyCBUYJt23iex6J3nQp2v0rHreK0r+k6tzidG2zhjRpMA4tAGQQTg6kyl32oWjgDCQzkqWNfbjiboSYhzu5vRsU14uYxyfMDSVQhfqoSyzhPdNKXBunzv14EWZ3eqIc2nac8SmAQhagkRXkKr7BDVDphUXkq8jdZ9rU0fV1K34/RRoZN++4et2Xir2+QuS7LyrPF51v54jSpwVgC20clGlvbWLt7OHv7zKPoPSt7W57nP/IR+BdVKlFrGVJlSwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 8",
          "title": "Prep3 8",
          "src": "/learninghub/static/48e058a168370d98c4118aa626f3ce4e/3cbba/Prep3.8.png",
          "srcSet": ["/learninghub/static/48e058a168370d98c4118aa626f3ce4e/7fc1e/Prep3.8.png 288w", "/learninghub/static/48e058a168370d98c4118aa626f3ce4e/a5df1/Prep3.8.png 576w", "/learninghub/static/48e058a168370d98c4118aa626f3ce4e/3cbba/Prep3.8.png 1152w", "/learninghub/static/48e058a168370d98c4118aa626f3ce4e/0b124/Prep3.8.png 1728w", "/learninghub/static/48e058a168370d98c4118aa626f3ce4e/7d88d/Prep3.8.png 2160w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.6 Next, you will create an application representing App Connect Enterprise, and then retrieve the Consumer Key and Consumer Secret. Click the `}<strong parentName="p">{`cogwheel`}</strong>{` icon (1) and select `}<strong parentName="p">{`Setup`}</strong>{` (2).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "29.166666666666668%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABQUlEQVQY03WQyU7CUBRA+9mu/ARduHNr3DgEMXFjYkxMBI0EjVYjFVoROr6WoX0tfUg8voIYNy5Ozh0X9xpmMCWeZCRTyaxUFGpBmpc6z8gKhZzNyTR/XZHruXkYEbbbjE0T77hGYTsYJ9evHF1b7F2YbNVuObx6oaZrSxodThrWknrzx1Wu41PdszY2cepnJM9PdLd3ON89wJBZymKu8BPJ/uUjpmXTex/QdQa4QUwgRvhroork10M31Hv6On2JlytOW+8YQkQIIUhlif0R8mZ7WD1XL6SIUUGU5EvEaEY8XiGWLvWrFLGe8SKJ64/p9AWG73uEYUBafBJ93OP3r3CHN/gar7JbuUkU3CHTZ3KNTM2Vp2s/UWQdet4EYzqZkMsMqb6IBw+MwhZl2UeVDmrmUK4pbD7nff2e/xjSdcd8A3VutzfZBNjFAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 9",
          "title": "Prep3 9",
          "src": "/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/3cbba/Prep3.9.png",
          "srcSet": ["/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/7fc1e/Prep3.9.png 288w", "/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/a5df1/Prep3.9.png 576w", "/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/3cbba/Prep3.9.png 1152w", "/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/0b124/Prep3.9.png 1728w", "/learninghub/static/135e5aa4005e5770ee5dc05088d3a81a/f6b9a/Prep3.9.png 2162w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.7 In the navigator on the left-hand side, scroll to `}<strong parentName="p">{`PLATFORM TOOLS`}</strong>{`, expand `}<strong parentName="p">{`Apps`}</strong>{` (1), and click `}<strong parentName="p">{`App Manager`}</strong>{` (2).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "49.30555555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAACSklEQVQoz4WSTW8SYRDH+VKe/ATGeDVejAc/gjFNvNT0okmNxsaoMbbFECq2iS+NbUoLaLHUWkopCKVQoLALu7wtBbqwy+vPZ8FDDyZO8s/M8595ZpL/jG3x9IJUswcMGQyHjG3Yh0GP/9qoT9doj2sHPRNd72A7kRROczKK1iApl/EEk+wlZA5O1TFC6dI/YeWCyeIEKYV94S3e1mw2uNDb44Fas8NDV4Av34PkZRVZrZEvVpCUqsDE5xWNXLGGUj6nVNeR1DpSqUGhbhA8KWJrNZtYsKzR7rHiT+A+SOIOZ3FH8/hiBTxRgXgRj4i3o2kCiRyu7QPmlz/jCUVY8++yvOrGFzrDdmF26Vvd+l2qYrpzK8AH3zLe4xSL7k2e2KeZX7czbZ/l3usZ3szd5f3Lm1y7f5sbt64Scs7w9tUUV+5cZ8lziK20s0M1maT8YIrsgoPVozSb35zkT34QC6zi2VggkVjHv73Ac/sjXjhmWVyZ492Gi49rTo6jPlxfnTz7tIT3MIutvPeL3M9dat4tzkJR9hMVjLaJXFBR1ApNoatuQE8sXavWOdcm8hjGiJp4S7JCuVSh02qzGxdLGYmkpKq0+300h4PM46fjD13TxLS6MKIjZBGa0Ol2Mbvm+Fx0w/ID6s2WaG4wErE/KpbSE0WyJGGYBlqljtsbJVPSieXOiWQ1Evk6R+nq2EeyNWJnGseXuHBG47fg4jkNz6GMrWs1lGUG/R6d3ohwqkAwkiQcz4zPoVjTJ6jqKLUJrPgyV/zLS+UWfwBFt8e9JizZXwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image3 7",
          "title": "prep image3 7",
          "src": "/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/3cbba/prep-image3.7.png",
          "srcSet": ["/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/7fc1e/prep-image3.7.png 288w", "/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/a5df1/prep-image3.7.png 576w", "/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/3cbba/prep-image3.7.png 1152w", "/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/0b124/prep-image3.7.png 1728w", "/learninghub/static/3268128bb5a0a6c29dd144129d5f6a41/3fef4/prep-image3.7.png 1808w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.8 Click `}<strong parentName="p">{`New Connected App`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.208333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACIklEQVQoz12T+W7TQBDG/f7vAM+A+AsJgRBUTZXSNhEhLTRnfazt9R6+HTv2x8y2VAJLnzxr7fzmtPf+UGCra+RVg6JuMA4DulOPuulw6s/oz6PTaTj/I/7WdSfYskI3jijZrjt4aSwg4gS6KHH584g3H27wdbnD1fqIGZ0vVwen+YOP61/hq+YPIWa/E8zm9/j27jMuWJ+u4QkhkGUKwIjVQeLtxzvMF2vcLtdYrB5w9+Me3xcrbI8hwkTBFxKByPAUZdjGFo/rLZZfZqQr3FzcwivLEnVdgx9fKByeIhx8gc0hwGYfYEfnzd53YijDGMwSSQYhDYTKEUkNP83h5XmOpmkcUEiLvCgQiwht26CqSkRhgCK30CpDU1foT9RbUpZJJEkMozWs0WjortIELAjQdd0rsG5aRFHkGj7QgIIgIHiL/x9FIG5XmqYEz4BpQpIZeDYvYGyOnpxjVVD5jbvY9z1lcnqBd85mMFfDtlKKMkwckO2JJu2ARd3icbentakgbUMOLcIwdFG5t5wh2+zI31lSSqe/QE3ZjuP5GTgMPXzfR0uRTdGiogzjOKZ37TJhAGfFw+P2sPjMQWIHlLA0h2miDGlAHpfDTuP5TLtIQMpUa16jiUptYcxLdBqAoPJDytgaQ0OikimwlKnz4fupsvC4L1obF8GWHZShaZkcXU/noiab+tpSL2NJayLdO5bPKxOKBCLNYPIKFf1Zma3wBwRTO0nTj/d3AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image3 8",
          "title": "prep image3 8",
          "src": "/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/3cbba/prep-image3.8.png",
          "srcSet": ["/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/7fc1e/prep-image3.8.png 288w", "/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/a5df1/prep-image3.8.png 576w", "/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/3cbba/prep-image3.8.png 1152w", "/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/0b124/prep-image3.8.png 1728w", "/learninghub/static/8a9e4e35caa3d48a4b52fc7d6b55673b/382d6/prep-image3.8.png 1798w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.9 Enter `}<strong parentName="p">{`App Connect`}</strong>{` (1) as the `}<strong parentName="p">{`Connect App Name`}</strong>{` and your email as the `}<strong parentName="p">{`Contact Email`}</strong>{` (2). Select `}<strong parentName="p">{`Enable OAuth Settings`}</strong>{` (3).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "51.388888888888886%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABzklEQVQoz4WSW2/TQBBG/b+BhwqeKW99L0VF9C8kAQoiSG0KpQUhaJPGTRwnvt8va/swdhpCeYCRjsYzu/52Zme1BwfvePH6nI/nPzj5OuZybHBxPV9zdcf1H7nrTWz8/r4Uvk0WfPppoB29uaA//MzbD6ecfvnOrekyNRxmptehL330hdPRrrXoGxbreDx3uNJNYYlmrjziKMTzQ4I4oQYqIc4LEqFOM5TEShZKVVFWtfgtSuKkqIiSFNvx0Cw/ZbWyMYVIRK3JlMAwccwVq5MR9qOHeDc6UZSQiUCaFWR5SSp0Ps1xXU/EXCzHR/PjHJoaL4rRR2e839nhbG+P6ctD5kevuNnf5/bgOfazXchlb2tNw9Ya6rqmrqquy7WgmC2nmOMJ814PvT9gNhhgD4f4I6ny+Bhr9ymV697pNffYCHt+tBXMspwgjJgtTAxTWK5Ydm24FFKB2vz2l9hWtCGW9rUgKbqNSil8z8cLAtxQhmQ7lFlGWZaUMhxVFPzP2jvVLC/B9wPmxpLF0iKYGYQyIOvJY9xen7iduAwkkdPzQpEVpfj7rHNKKizQnCAjCEJMEWvvMZzNyS2LdDqlkLxq2uqrjvIfKBlKIi/gF6sK8Boc+MQyAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image3 9",
          "title": "prep image3 9",
          "src": "/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/3cbba/prep-image3.9.png",
          "srcSet": ["/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/7fc1e/prep-image3.9.png 288w", "/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/a5df1/prep-image3.9.png 576w", "/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/3cbba/prep-image3.9.png 1152w", "/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/0b124/prep-image3.9.png 1728w", "/learninghub/static/64c7639f4f5c8c37200818bebdce97c3/a29a0/prep-image3.9.png 1786w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.10 Select `}<strong parentName="p">{`Enable for Device Flow`}</strong>{` (1). Now select `}<strong parentName="p">{`Manage user data via APIs (api)`}</strong>{` (2) as the `}<strong parentName="p">{`Selected OAuth Scopes`}</strong>{`. Click `}<strong parentName="p">{`Add`}</strong>{` (3)`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "55.55555555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAAB9UlEQVQoz4VSTW/TQBD1j+NXcEdCQkL9Cb1wRVXJpRLiViQQdwQCtQdahJImpI3jpErsxHac2F5/ZO3YTvzxGLt2GzjQkZ52NDv79s3bFQ7f/8DJ5y7OuxOc9ya4HMxwcUO4VnDRl6v8cjC/q9Uoe+77BrO/eoTTMxGfzrr41emj/XuI+dKFanrQGIfGE6hLB6rBaG3gPOTGXo1yjVZBtwKsTIa+OMFgNIWhzWDrNoyfHeivj8GcAPY6gu2FsP3Nf+GuNxD8cIsyAh7A91wEigRHlsFGEoyPHxCs10BRUEeBx6OA4KzjKkmSLZIoRsRDpESQ1hRZnletaZoSb1HhPmivKFHXoiiC4JJPeZaBMRee6yHhvDq8TRIwy4JpmvB9Hxn1ZDUpD0NYjCFudNWXBkFACvldubqENuaSBInGHY9HFSRpCF3XiNRDkMTYEfHGccAWC0Rfv6CgvNH8D2FREc6kW4jiLVTVICKTlHPEcY5NlCHXDViTCUJFQaLOwVpvsFNVNIp2u90DYe0phm9foX30Ar3WAa6OX+Lq6BmuW88hvTuA/PQJrG/fUQ5YIm2O1R7mJKh6lDiOwYMQIfmnDzuQpR6UGlOxjcX0BktFhCaPydttpSYlNTl5ir2HKn0WbG9Tze77HKvVEkUWPv45apJ9NIR/ANb7NvVD8I1cAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image3 10",
          "title": "prep image3 10",
          "src": "/learninghub/static/0c23781d506a258898bd78e99806cc06/3cbba/prep-image3.10.png",
          "srcSet": ["/learninghub/static/0c23781d506a258898bd78e99806cc06/7fc1e/prep-image3.10.png 288w", "/learninghub/static/0c23781d506a258898bd78e99806cc06/a5df1/prep-image3.10.png 576w", "/learninghub/static/0c23781d506a258898bd78e99806cc06/3cbba/prep-image3.10.png 1152w", "/learninghub/static/0c23781d506a258898bd78e99806cc06/0b124/prep-image3.10.png 1728w", "/learninghub/static/0c23781d506a258898bd78e99806cc06/e0c97/prep-image3.10.png 1780w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.11 Click `}<strong parentName="p">{`Save`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABqklEQVQoz42S32/bIBDH/f+/7N/Y8972Mmma9tCoWldNs7s26vLDcWLANjFgjE3y3YHTRtqytid9DD7gewd3ybsPM3y+mePL9zmu0tXEz+UEzWfZ6uw/8bcv/F/frfHx+hHJ+0/f8PWKmN1gkTPkuxqbWqGodZy/xppYFAKrguF2vkMiOEdelFgTUnWwHuDpL5TZPYzzMHa4iD6NihDKgVcVltsGidy3YLxCZ3v0/QDnj6jSDMXtD9hhRO+GFxihlUZVN6iqGlvRIjl4Dyn34Fzgd5bi4T6j6IaEB3SdjYEs4f0Bx+PxHzydHyiwtRYFJ0GQhYO7LYNkC4jdHA17hDM8LMVDh8Mk9pqxxpwFpZQQlHbJBFiAh5FBax0zCKJPAS5Bn7NgMGM6lGWJzWaDPM9jAGNMvIpz7g0ZngSHgSqlTCyM1ha2d5HOTpiuJ0iUshxG/19GessoWDcS2d0DUmoTUS5hXWiH/lnQUuWDL44v4GjP85VDpTu6nhEFZdtSpiqi2hZ+HPFW47JDojsHRYQmbXgTm3uvbCTO6RmadvKFfcpcIPp7FELhDzAMlb5PGH9wAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image3 11",
          "title": "prep image3 11",
          "src": "/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/3cbba/prep-image3.11.png",
          "srcSet": ["/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/7fc1e/prep-image3.11.png 288w", "/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/a5df1/prep-image3.11.png 576w", "/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/3cbba/prep-image3.11.png 1152w", "/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/0b124/prep-image3.11.png 1728w", "/learninghub/static/4a5d647ab55ba2cc59abae855e0bc45f/d69d0/prep-image3.11.png 1782w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.12 It will take approximately 10 minutes for the new connected app to register in Salesforce. Once it does, you should see `}<strong parentName="p">{`Manage Consumer Details`}</strong>{` displayed. Click `}<strong parentName="p">{`Manage Consumer Details,`}</strong>{` following any authentication directions.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.958333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABpklEQVQoz4WSW0/bQBCF9/+/8FeQKtT2vYKqJRCKgDSEkDh41/fLXuy1vfZhbLdSW1Ix0qe1VjNnZs+Yne400qqFqRv0vcPvcK4Dhh7vRdtYNLZG2zYopQbzwgR7X0CkOW42Pj5cPGCxfsHl6jBx/chx8xS8ZTuz3IiJH/S9oFyWRCFkWVKvAd9WLzg5vcD54g5fr+/x5fIWV3dPWHshfu4CrHbiDeP9w/N4Cny/34MFQYA4jtE0DQ4ixeb5AM8PUbcOddOhsh10ZScq2x5FkWWZNDjwECzLMmitJz/CpIQ0lhKav7xUSlJD+66fWS7BpJSwdk6Oc41Cz5NksoLrB5SlBOcCSZLQ0vr/gmFAnBZg43TOzdtNZQ2eqmnjIlOoqhqCxDjn8DxvyhuocKDtz+fMJEhRKAOmFAkY8+vCotQ1lKlhyL8xTOegtCHxigqHo9O5SXCApFo2PjeKIiowyGnCLCvAgwj++hHbs4/YfvoMHSfoSKwj8c4dge5H4VKRYNu2EEIgz3OakH7QrkMYxfD3HnaLK+yXSxTkX02N/3zmv4yhaKGvOAX7zoSl2GgAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep3 15",
          "title": "Prep3 15",
          "src": "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/3cbba/Prep3.15.png",
          "srcSet": ["/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/7fc1e/Prep3.15.png 288w", "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/a5df1/Prep3.15.png 576w", "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/3cbba/Prep3.15.png 1152w", "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/0b124/Prep3.15.png 1728w", "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/4ea69/Prep3.15.png 2304w", "/learninghub/static/ceb36cba43379692a1cd86f0aefe9358/1566f/Prep3.15.png 2382w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`6.13 Save the `}<strong parentName="p">{`Consumer Key`}</strong>{` and `}<strong parentName="p">{`Consumer Secret.`}</strong><br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "27.083333333333332%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAABYlAAAWJQFJUiTwAAABDklEQVQY01WQyU7DQBBE/f93DvwDN45IOXEBhEIwZMF2MnZsxvbMeI+zEOUxOICgpacutUrVrXYub18ZPXtkRYU0JaqqEblBFjWqbsmrM19alg2BKvHzEqErQktkauKi4SZIeYgNziQIcT3BkxfyImImvhhMeX8g63Zkm/+kw2z/S9pukVWHajaEpsHx04JYNRh7UTCe4N49osSaozEWzVHrc//Dh1YclCXPOHUtP2X6PY4nNV6YoqKY1nXRYUj25hFaHU+nvM/nJLPZoOViMWgdBBRCUPo+vZ2dhrgTub3euRpnXIwSru9j9tawTRI6a85sQL1c0q5WNLY3f3QfRRykZGeX79br70DI7Us+Ad6Uc350zeYOAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "salesforce key secret",
          "title": "salesforce key secret",
          "src": "/learninghub/static/87058372248f195cd0701e872449f711/3cbba/salesforce-key-secret.png",
          "srcSet": ["/learninghub/static/87058372248f195cd0701e872449f711/7fc1e/salesforce-key-secret.png 288w", "/learninghub/static/87058372248f195cd0701e872449f711/a5df1/salesforce-key-secret.png 576w", "/learninghub/static/87058372248f195cd0701e872449f711/3cbba/salesforce-key-secret.png 1152w", "/learninghub/static/87058372248f195cd0701e872449f711/4c2f1/salesforce-key-secret.png 1555w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`Your Salesforce developer account is ready.`}</p>
    <br />
    <hr></hr>
    <h3>{`7 - Set up Insightly`}</h3>
    <p>{`Next, let’s set up Insightly, a cloud-based customer relationship management (CRM) solution.`}</p>
    <p>{`We will create a trial account that lasts for 15 days. After the trial period, you can migrate your trial account to a free account (with limited users).`}</p>
    <p>{`7.1 Go to `}<a href="https://www.insightly.com/" target="_blank" rel="noreferrer">{`Insightly`}</a>{` and click `}<strong parentName="p">{`Try CRM Free`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "54.513888888888886%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC8klEQVQoz22SXUyTVxjHz1soFYqfc9OL6byZmSgONeKCQgUm21ATnQY/gVEk25JdbDfLskSTZUs0LjFeGBP1xpgtmogkRpkg7WRVFKRaDagog/JR6lZa+olp+wI/n9fLZSc5OSfPyfmd//P/H3XyfcW5DxQt25bz544VtBVmcrckG7fNgqfEzKNyKx0bzXTYrLg+MtFeqOgoUvR9amaodi7eukV4a+fh26oYrV6CupCncXW1otW2EGf5O9xYZ+KWXOwoysRdkoWnLJtOWw6u0jnckUe6bSa6ihW9H2sM7rHir3mLf+rmENipCNa9i2pbo7gp0/mh4nq+4mK+xh+FZu4WW3BXLMBdloun1Ezn5gweV+bSt/Nteios9FaY8W0zERHQRFUmgQOKcIMobBTI7ysFVqDRulbjSoGJa+szuV+cxYONGr37ljPyUxX9h3fxoj6f3vIMnn9mYaAyi1BVNrF9s4gfsBLZrxH5einqN4FdWqVoWq3Rsk7DIR41F1lwbsqie71icNcixr4rZuz7LQx8LuqMWqkisF0Rq55PvHYhifrFAs0h8c0ylAFqEg+vG21LIO0Fijs/H+LabTfNZ04y3niKkaN2hs4f5+mJH/EeOYjPnkdo72xi++cSq8klWjObyO4MgnZR2LpGlBkwUde+QYBrJcFfGzDG8L9BYlMQmEzjDcYZSsGTwAzPxlMETn9JQvyLfpFLuNZKeLeEYn8PdUO8M4JxCfC2AP8StT2/NJA0gAP9TMZi+P1+fKMjMK0Tik8Ql7PohR8IS9uR6hzC1dkEdihCdgmlSTxslmDaBdq1QcOVJ1/i2FdMzsDTvn6i0TCjg32Mv/QjYplIxBGhBM9+i0++j79SY+QTxXCZYrxePAx2Ogh1tjHR5SDa7WTY0ciw5x5T0zOM+fzEBDA26iUcCr6xIamnmZY15XtB0t3CpNtB4uEt4s6LvHJdRvE/Qxd1uq6TSqVIp3XS+hRJ2Rs1XfbGOvPfO3/3kPS4eA3bzUf4RgtfDgAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep insightly 1",
          "title": "prep insightly 1",
          "src": "/learninghub/static/c4d5388e76cd8cdd8ade5c02820033c7/3cbba/prep-insightly-1.png",
          "srcSet": ["/learninghub/static/c4d5388e76cd8cdd8ade5c02820033c7/7fc1e/prep-insightly-1.png 288w", "/learninghub/static/c4d5388e76cd8cdd8ade5c02820033c7/a5df1/prep-insightly-1.png 576w", "/learninghub/static/c4d5388e76cd8cdd8ade5c02820033c7/3cbba/prep-insightly-1.png 1152w", "/learninghub/static/c4d5388e76cd8cdd8ade5c02820033c7/fee9f/prep-insightly-1.png 1481w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.2 Complete the form with your personal data to create a free Insightly account. Accept the `}<strong parentName="p">{`Terms of Service and Privacy Policy`}</strong>{` and click `}<strong parentName="p">{`Create My Account`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "50%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2UlEQVQoz51TTQ+CMAzl//8nvRo9ycXEGL8APQBijG6E0e25DiQLAYM2eWnXPB5t1wXGGLD53gebTmPo6xEtocsPWdAX9GMiQp7nSJMI+SXGrShcrs//KuhXxh8LISDKEi8hXTzEmyxY1wStddO29cbr4E/BGmRhszAsaOGEB8Y0SVBWCg9ZQqraVcegHve3GRYZxGmHZ3SATM6okiPMPWvEp7TsYl9wv4FazaHCBaq1xXIGtQ0H1+uDYGxl2JdkZ8azbMGxUNT9dFKF/lnbtTE+NDWXM/IIGG/hFRV8bWasgwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep insightly 2",
          "title": "prep insightly 2",
          "src": "/learninghub/static/40e5fcfc04dbe365fa03d8d2d92b8e09/3cbba/prep-insightly-2.png",
          "srcSet": ["/learninghub/static/40e5fcfc04dbe365fa03d8d2d92b8e09/7fc1e/prep-insightly-2.png 288w", "/learninghub/static/40e5fcfc04dbe365fa03d8d2d92b8e09/a5df1/prep-insightly-2.png 576w", "/learninghub/static/40e5fcfc04dbe365fa03d8d2d92b8e09/3cbba/prep-insightly-2.png 1152w", "/learninghub/static/40e5fcfc04dbe365fa03d8d2d92b8e09/fee9f/prep-insightly-2.png 1481w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.3 Confirm your email address.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1003px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.083333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA1UlEQVQoz41Syw6CMBDk/++ejB+hid68GhPxpkFD4gEQ8YHxQin0MUIDCAWETTbd3U6nO9sa0ExKqbwe51nlRV7u62agxypwtoqTCb5fA0ncunSQsN4dYwxJmoLFBPTzRppQVatjRhGWwDAM4boe/OCO4PGC613hOE5bRR+hPj9KaRbxzFnhQtWEEL3S/0rODx8vT2wPPnbWDaYVIIpIg3CwQ/3mxcbFZH7GdGljtrLBhGxhR0vufsmyPoKw8fcKHOMCJOUgCVcxtD85WvKvk64Zy17JX09GE92yYui/AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep insightly 3",
          "title": "prep insightly 3",
          "src": "/learninghub/static/12fbd14695fd45c17f01e0518cd005ff/a9c44/prep-insightly-3.png",
          "srcSet": ["/learninghub/static/12fbd14695fd45c17f01e0518cd005ff/7fc1e/prep-insightly-3.png 288w", "/learninghub/static/12fbd14695fd45c17f01e0518cd005ff/a5df1/prep-insightly-3.png 576w", "/learninghub/static/12fbd14695fd45c17f01e0518cd005ff/a9c44/prep-insightly-3.png 1003w"],
          "sizes": "(max-width: 1003px) 100vw, 1003px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "53.47222222222222%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsTAAALEwEAmpwYAAABIklEQVQoz4VS7W6DMAzk/Z9qD7Afk/Z33TRtUrWGACHkO3Cz06VibaGWLCfgu9hnN/M843QSEKJF27YQ5NZoTFoh5wy2ZVk2nfE1WmvROOeITEDKDl3XIcZYSOY/wJ6llMB4733BcQFNfWFtOTjMORVSTtrza2vqoZAyAZ3NyxO+Xp/x9vGJ98OhSDGOI5RSN34tS7PWo7aagkegNs6thALi9u55xV0I1xXWn8Y6qHGCnixGrWGM2dRzTXjTcv2oJo8fadCpiEGZ0hpPcGviDwm5QjEoDNbDhrQ76V3CGh1pZ2gd/jk9Yh1pG0JZkUg6R8qbHxHyGvX9eSdZO0XTPQqJb1r+YyvLXU+kby+LZ8p/WOF6cbkajrlMNV7unLXcwf0CUpJgNkqAFPYAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep insightly 4",
          "title": "prep insightly 4",
          "src": "/learninghub/static/2972b3abc35a65efcff812dbb598b5e1/3cbba/prep-insightly-4.png",
          "srcSet": ["/learninghub/static/2972b3abc35a65efcff812dbb598b5e1/7fc1e/prep-insightly-4.png 288w", "/learninghub/static/2972b3abc35a65efcff812dbb598b5e1/a5df1/prep-insightly-4.png 576w", "/learninghub/static/2972b3abc35a65efcff812dbb598b5e1/3cbba/prep-insightly-4.png 1152w", "/learninghub/static/2972b3abc35a65efcff812dbb598b5e1/e78c6/prep-insightly-4.png 1156w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.4 As soon as you click the link to confirm your email, you should see an initial Insightly screen asking basic information about your company.`}<br /><br />{`Write `}<strong parentName="p">{`demo`}</strong>{` (1), select `}<strong parentName="p">{`1-5`}</strong>{` (2), select `}<strong parentName="p">{`IT Services`}</strong>{` (3), and fill in any phone number (4), matching the screenshot below. Click `}<strong parentName="p">{`Let’s go!`}</strong>{` (5).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.43055555555556%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAACbklEQVQoz1WSz0tUURzF55+IFiHVJhcVtoggWhQVJIqZM9rMvHnz3rwf80NatSpLrTaWEsXYpMOoYzSWgSmW0MZaiEqBaxHNFDRNnTLMUEeNT/c+m0UXDtzLvd9zzznfr0s9VoB+shC96BDa0QPoxwtQC/dTe+U8ffFGMvfv8PKBQONdMg119LcnaNDcKEf2YRYdJCTeS8h6/cRhXIqqEjJMAsGgg2ismqteLx3pDuTaEljf3uG3xM4u5LZ51/8GXyCAYdloho1l22JvOXBpmkZI1zFNE1tcxGIxLhVXUHuvmdyXz2SHh8mOjPBDIDs6wlpTIz3JJIqoidgGllKOJYhkvWEYuALiJ0kaDoeJRCJURyN4NIsbVRaTt28xmu5kaXyc5ZkZvk1MsLuxwdv+1yhKgFgkSHH5WaEyjJUnVNUAuvjNti1HoSRWgiqpx4+YHRpi7P0H5hcW+Do9zeziIjkRwUBPF77LxYRFPIZ4L+skmVTpCorc5EFRVPx+hWg0ildm2JkmNzfHytgYq8L2Ul0t3z99hKkp+tJpPBcvOJmF/4n4z7JUGNQM3J6guAg7xPEnKX4ODjKZaGYy2cJMe4q57hesPmyiW7iqKi/fa4YgySt0CHWnIYbI0cRdqVFSpuLz+oi3PmM908yCfpr5a6UsX69g0T7HaqCEV4kWFEFqGqIxYUu4iuxZloRSqkQoFHIgs/T7/WQyz52xWVteEbPzi63NTf6sZEHkONDbi0/xU1oW5NSZSry+vTrDFGOTD1MqlciPQM3NGifHZKqNeCLJ09YUybY2Orq6qKuvRxPZ+xWDCo+GppuOfdNdyl/EiPKouiDHtQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image4 4",
          "title": "prep image4 4",
          "src": "/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/3cbba/prep-image4.4.png",
          "srcSet": ["/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/7fc1e/prep-image4.4.png 288w", "/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/a5df1/prep-image4.4.png 576w", "/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/3cbba/prep-image4.4.png 1152w", "/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/0b124/prep-image4.4.png 1728w", "/learninghub/static/b1ab7df13c5194ee06654b65da6d6ba1/ca4f5/prep-image4.4.png 2052w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.5 Close the `}<strong parentName="p">{`Invite your team`}</strong>{` dialog.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.77777777777778%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAABYlAAAWJQFJUiTwAAACcUlEQVQozz2Sy2sTURTGs66FutClVruo/4AKbkW6qFTb5tVMZua+ZjImwWIXYh8btQtbWqwLRQX3gn+A7qQW3Yqg4FrcKC0madK8J5/n3FQHPg53Zs53f+e7N+FOnoY3cRLu+Am4Z1kj0JOncD85hXVnBg+y03h4LF6vU129fAHyzAi8c6Pwx0fhsSbG4J4fQ0LmsnBTc8jP3YDJZeCnZrG6dBu9bhf9fh+VSgUHBwfY399HrVYD4hg/9z6glJ6Hl0lCZlIwThZqIQ1N/QmpFITSUCZAeKuErOMjiJbQ6XTQbrfRaByRGlb1eh092qRKtVAsQVFvIVAICpHtZyV8z0MYBCgUQoRhCM/1MZ1eRK3exGAQo9frE1SMLhFz5adS+YNSeREydw1zs1PQJoJW0m6QEEIgsIYFK/5wZ2UNjWYLA6LptlvoEW2n1aTaHhpWqyiXyshLB0nfo/7QmimtaWQpIaWAoA+aXrhEvLaybEdsEVAfQ3WPKz9VyjUMAwghUYwiGGOsoR4aCuRyHlLpPIrFyJov31tGk7p7P75j8PYlBntvMNh9jfjdK8L7heohZUgmDMNTGc7vn6Hi2XWAVEZg5qZrfyqV7+KoQ3i134g/v0f87RPirx8Rf9kFmoeoEX1ERp7nWlKOzBpyhsZo+L5GZkFiPuXTGIpIS9jc3MTW4x1sP3uB7afPrba47jzBxsYjojHIOR58of8b2gwZUwgfkmSMsnkM8xF04i6y6SQcvqt5B67jIE9iMs9XuHgliUskITUM+SiazhqyFN1FzoKvDucSUdhRVKBsPSRTfGDD0XhDFvfwmk+Y+zRlb65fxV9JLC96tjtvAAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image4 5",
          "title": "prep image4 5",
          "src": "/learninghub/static/ec599d83559fac5e218a798099c5b673/3cbba/prep-image4.5.png",
          "srcSet": ["/learninghub/static/ec599d83559fac5e218a798099c5b673/7fc1e/prep-image4.5.png 288w", "/learninghub/static/ec599d83559fac5e218a798099c5b673/a5df1/prep-image4.5.png 576w", "/learninghub/static/ec599d83559fac5e218a798099c5b673/3cbba/prep-image4.5.png 1152w", "/learninghub/static/ec599d83559fac5e218a798099c5b673/0b124/prep-image4.5.png 1728w", "/learninghub/static/ec599d83559fac5e218a798099c5b673/d7c9e/prep-image4.5.png 2054w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.6 You have an Insightly account. Let’s get the API key to enable App Connect to authenticate when making API calls. Click the `}<strong parentName="p">{`Profile`}</strong>{` (1) icon in Insightly and select `}<strong parentName="p">{`User Settings`}</strong>{` (2).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.56944444444444%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAACNUlEQVQoz2VSS2sTURSeH+HvceHClVpEcCkoXbgQpC6kuqiI1Aoqou4Edz62LpVQpWAVbFJopSGBaBpN0klmknnk3rmvmXx+M2lXXjicO3MP53yP46kXt6AfXIFeXYK6fQ529QLc3Yuwj5ZhH1+H3bgGx7DrV2EfMq9drmrsnSW4m2dhbpyBWDkPcX8Z+uNbeKF/hNFwiOFggDAYQ0rBmEGKFEZJZPyepSm0yqCy45ASOs8x3lhH8HkT424H/rdNZKM+PCEzjIMQfTYsjzEOnV+HGPSH0CZHmgr0ej3M8f9RQkAohYxDXBLCcLgXhiGstVWBlBa5c3j1poXTlz5h5d4PaF2+zeHyApLDpHYotKjqc6KUbBr4PpLpFJbIvSiKWJxXBScomr7CqWc/8boeLgbZHLE0mJFNohxMqwb0d+D4NqNkW+9q+LL2HEdPn8BLkgRKacKWzBmzgnMG/qwLZVOiJ22iVKQ2L8rBBfWbI9//ADftQ2QGwXiCOIyh2MtLKXhEuGHM6VJTQ43u4R9MRgFN0RXFVC6aGVvAHwkkVGHS2EWyW0dWzGlaQr11xdSbTqhhydX/CvN3p6Ld7gTYOxgtTGLRjCgwp46uoMu2ohptbyOuN6D4v9RRMEoWdHkhcLP1Eu+/b1f3OFFotkPUtnqIUwPLpvmxztWQggZ1u9BBgMwYrpakoVwlreGVl9w6xNQtLuhg7vC7F+GgPUVjf4QolgvDiOQkSrRVY25Eia5cm5OG/wB2AuKWlzsG1AAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image4 6",
          "title": "prep image4 6",
          "src": "/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/3cbba/prep-image4.6.png",
          "srcSet": ["/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/7fc1e/prep-image4.6.png 288w", "/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/a5df1/prep-image4.6.png 576w", "/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/3cbba/prep-image4.6.png 1152w", "/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/0b124/prep-image4.6.png 1728w", "/learninghub/static/8902a7cb2c0f103b171b85aa499e8c95/a29a0/prep-image4.6.png 1786w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.7 Scroll down to the bottom of the page and copy the `}<strong parentName="p">{`API key`}</strong>{`, which is a long string of characters.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.91666666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABgElEQVQoz52R3UrDQBCF8xiKeivqlT+I7yDinRVBRXxLQaxaJVq1TQUv9EIEcdOkiSl2k22ymxxn0xh/aEVc+JLdmTknsxOD7S3jpTILtjYJtjoGe30K7sY0nN1F2PsrsHcWYG/Po03v9u4SXIq7W3N5na5nq+OknQDbnAOrzMAQ1hni5gnExQFgnSBrVqGuD5FQLLFqkK0a7U/Rv6kibhwDtzWgUc1r0Tr95M6EJI3h8wgJgJTIiD7BFeD1Inh8QBDFZX4UOh/Rw/A7LpI+2WQpMiULFCLO0XEddINX8Lc3UqicbAh5nDQi5DAcx0GS6B7JM8uQpml+juMYioq+Lp0fxkdOCAEjCIJvhtpE0blPyZCHkLRXUhZijFyloe/7kCQowhBxAi+M0RWDuf2QjeyyNPQ8b9Bh8XnRboOZJlj9CjbBLi/hWRZ6IY1Bpnndr4b6ynmHhSF3XTxWj/B0buK53oB73UDv4Z5qUprvHzqMoqicoTaV9FP0ADTqH1d+B1VG6LtasjDlAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image4 7",
          "title": "prep image4 7",
          "src": "/learninghub/static/22296e145ea85dfac87f647cc6b81705/3cbba/prep-image4.7.png",
          "srcSet": ["/learninghub/static/22296e145ea85dfac87f647cc6b81705/7fc1e/prep-image4.7.png 288w", "/learninghub/static/22296e145ea85dfac87f647cc6b81705/a5df1/prep-image4.7.png 576w", "/learninghub/static/22296e145ea85dfac87f647cc6b81705/3cbba/prep-image4.7.png 1152w", "/learninghub/static/22296e145ea85dfac87f647cc6b81705/0b124/prep-image4.7.png 1728w", "/learninghub/static/22296e145ea85dfac87f647cc6b81705/6a339/prep-image4.7.png 2048w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.8 On the `}<strong parentName="p">{`Free`}</strong>{` plan tile, click `}<strong parentName="p">{`Select Plan`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.944444444444443%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABaElEQVQY022Pz0sCQRzF9//oB7lrpVAUu7YduhYVUUH3/ooOFUT0B2hipywUgm5d6lAYpGFubOKqaQVCtGCXXElNN5ZWWV+zY0VEA4/5MvPeZ94w8qIb8vIE5KUhyLN9uJ7uxdVkFxJTPZBmHV9ikZh3QVpwQ5rrJ/fd1GN7ZXJv526I4jMOMMO8B7ZGxkSwg26sbmwimbnFeewSsYQEJZeHks0iHT1D5uIUipJCKneHwpOKlbV1OAZcGCXZbw7jEXjYGhdFODkO4VAI/65cFEhHgJYBq92mRzuBADiWpVnK4XkwAhkEQYBoA51O7AaD1FwuFtG2LJRKJTSbTbzWdWjVN5hkVlWVerxeLzhSws5STgco/ABZjkV4P4znQhKHB1swahUcP0bwomvIa/eIFyU0TB1HDyewCNC/7aeZDlAA/xdovxbcIw3JlzTSomWaqNUb+CD7u2Ggruu0bblSpQ19Pt+vhh3gJ9eHPTLwEY+EAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image4 9",
          "title": "prep image4 9",
          "src": "/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/3cbba/prep-image4.9.png",
          "srcSet": ["/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/7fc1e/prep-image4.9.png 288w", "/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/a5df1/prep-image4.9.png 576w", "/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/3cbba/prep-image4.9.png 1152w", "/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/0b124/prep-image4.9.png 1728w", "/learninghub/static/1d3d7e9f335747a3c5f46437a33f551f/ca4f5/prep-image4.9.png 2052w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`7.9 Click `}<strong parentName="p">{`OK`}</strong>{` on the confirmation dialog box.`}</p>
    <br />
    <p>{`Your Insightly account is ready to use.`}</p>
    <br />
    <hr></hr>
    <h3>{`8 - Connect Cloud Pak for Integration instance to your endpoints`}</h3>
    <p>{`Let’s configure our services endpoints in Cloud Pak for Integration.`}</p>
    <br />
    <p>{`8.1	Return to the command line and access the Platform Navigator using the provided URL. Copy and paste  the `}<strong parentName="p">{`Username`}</strong>{` (1) and `}<strong parentName="p">{`Password`}</strong>{` (2) from the command line output, and click `}<strong parentName="p">{`Sign In`}</strong>{` (3).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "39.23611111111111%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABJ0AAASdAHeZh94AAABm0lEQVQoz4WO3U/TUBjG+/d56R/BhQZQo3EQ8IOs88ILEy4JV0Rgg03hQhKCgB8BzAiQCQPWQteuW9sxoOVjW5nrfh4LkxCzeJJf3uecvM9zHin2CZ4mIJK85fk09KfgxYzgIwze8HLmmsEP8EzsjfbPMzRSJjIZ0Pfep2/iF1LkbZKHryfpiSZ48Go8pDc6Ra88LfREyKNYksdvUqHuGhijeyhOdyyFfO8+8pME0WEV+d0OciyNpOxlyGbW2dvZJL32lfTql3CufPvMqmAj/Z3Mxhpb6yv83PyBfrBLUVcoGSqHlom+rWJs6xhZnULmAOnU9TiqHFM5PsEslkJt2Q7FkoXjHOF6Z5xfXOKdnVOr+/zvSPm8xm42i5LLYRgGpmliFgrYtk3QbN5ZbrVaNMVbEAQdkUyrxKGWxy6XOfU8Tlz376z6PleCRq3GVaNBvV7HF/c/xvYH/zS0c/s4qkpF07BES1tRcEXDqmURiJCLeJzq7Oz19k1Qp7AwcF8YCgsL2EtL5ISxjTY3h7O8jLW4SFU0boe06RT6G9M0NEkyvad3AAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image209",
          "title": "prep image209",
          "src": "/learninghub/static/9e6f2d5ad2088e42bb0def0497e5b413/3cbba/prep-image209.png",
          "srcSet": ["/learninghub/static/9e6f2d5ad2088e42bb0def0497e5b413/7fc1e/prep-image209.png 288w", "/learninghub/static/9e6f2d5ad2088e42bb0def0497e5b413/a5df1/prep-image209.png 576w", "/learninghub/static/9e6f2d5ad2088e42bb0def0497e5b413/3cbba/prep-image209.png 1152w", "/learninghub/static/9e6f2d5ad2088e42bb0def0497e5b413/99434/prep-image209.png 1601w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.958333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABJ0AAASdAHeZh94AAACkElEQVQoz02S20tUURyFzx9gaKh4Je/iDOR9FCdH55IO460Zy5lR8ZI3fHBQKjXLCVOzB4XyD4heeqnA9CEoLMVblkpYjFiBEEE++BA+pDNi9bXPDqEfe3E4B86311p7K93d3XR1dUl1dHTQ1tZGc/NlmpqaaGhooLGxkdraWlwuN9XV1VRWVmIrK6OkpASTyURRURGFhYXyWVBQgOLxeOjs7KS9vZ2WlhYpl9OJw34Bt8uJ2+3iosMu3yvKyzAZi8nT5cqfDQaDlF6vR6fTkZWVhaK6OgFJN243vQNehkbHue4doffGEL2Dw/T0e/FcHaCn76aQF8clF/n5eUL55OTkSFhGRgZKa2uriNgsI9bV1YlYDnzbn1HnWOhI1YGfgP+IwPFvxJJz7/4kKSkpZGdnk5mZSXp6OlqtFkUF1dfXi45c1NTUUFFVxebqGw59PvY2Ntjf3mZvZJjDLR9/1E2OjiRwYnycpKQkCdNoNBKempqKohbvFJ2dFF5qs7E+N8+3Fy/ZefWa78sr7N4e5qdvi18CFDj0S+CYAJ6Ji0OTlibBycnJJCQkoKjOVJjdbhell2MVJ/h+aZHA22X2Vxfxr61wMPUEfuzx/0wODhIVGUliYiJxAhwbG0tUVBRKlYioOrNarfIqmC0W3s0vsrH8ibnZDyzN+1j7uMvq+ldWxLeF1R2+LGwyYyomVgDjhauYmBiio6OJiIj4B7SJmGazGaPRiNFkZObRY+5OPOfa6DT9d6a5NTbFwOgUfSPP8Hif8vDBLINXejgVclq6Cg8PlwoJCUEpFzFVZxbhTAWql9RiMeOwGrGXGKgyn8NaqKNUn8P5gmxMuWfJz9ASL6KGhYURGhpKcHCwhAUFBfEX8/PFpJWx+i4AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image210",
          "title": "prep image210",
          "src": "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/3cbba/prep-image210.png",
          "srcSet": ["/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/7fc1e/prep-image210.png 288w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/a5df1/prep-image210.png 576w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/3cbba/prep-image210.png 1152w", "/learninghub/static/1445cf4f93645d90e7af4449b9d4e861/5ca14/prep-image210.png 1405w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.2 You will be asked to provide a new password. Provide a new password and click `}<strong parentName="p">{`Submit`}</strong>{`. `}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1073px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.375%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABJ0AAASdAHeZh94AAACw0lEQVQoz2WTW0iTYRjHv2tBpxeiiIIuFx5w4rApc+rmCQwneEh0IvPIFh4uCuyqmworCIzqKokSMcVErDTdykgvSncIulHJ2nYRpM5DppuH7fPf+z4jGfXB73sPPO/ve5/3eT+hq6sLnZ2dMBqN6OjoQHt7O5qbm2FgdPf0wGS6TPMmowmNjY1oaWlBZWUlSkpKUFRUhMLCQhQUFECtViMvLw8CD25rayMJ51JtLVugg66iAhfLy2mhVquhRUrlBeTm5iBHqURmphyKrCyoVCoSKdmcQqGA0NraSkL+5fr6ejx6PIhJ8wLGXr3F6EsLRibNxPDEDIbGp8/g44cDQ1Dn55PoL4LBYABHr9ejuroay8srCH38IhBgiKdBQh+PZ4t2mJ6eznaciYyMDAhNTU20s7q6Ouh0OtjtdmbZwcHPVRxsfMP++lccMILtGvV9HhdwuA2X8ztULN20tDSkpqZCJpNBaGhooJ1VVVWhtLQ0KAxsYtv5EXs/vsC3sQLvehDfxiprl3HkWQN7we1y0tlJk5KQnJxMCDU1NSTklSsrK4PDYYfoP8HW5jqOD70sT/9/iP4jStntdkMulyM+Ph6JiYlISEiAwEUVrKJcptVqYbPZKHj31x68Ph9EdnD/4g8EKMblctG5cSGXxcXFQeAyniqX8fJbrUsUvLWzi32vjxWFC0SchHB04qcYp9OJlJQUREdHIzY2FjExMRDK2V3jwuLiYqiZ8NOSNVjC498svUPeYbAy4zQE8SxlqVSKyMhIREVFEQK/7RwNu/E57Ap8mJrGg34zum/OoLdvBlduvcH1exbc6H+H3jsWXLtrwdXbZvTdn4Pt9Sxk52WQSCQkjYiIgKDRaChd/usosrMxPzuLuSkHBoYXMTi6hGejVgyPWTHywoqnI2zMePJ8EeMTDnx+P4+kc1KEh4eTLCwsDH8ARJt8pUgfsd8AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep 501",
          "title": "prep 501",
          "src": "/learninghub/static/dca987c0fcae5f57c03e5100d76e1482/6a1d1/prep-501.png",
          "srcSet": ["/learninghub/static/dca987c0fcae5f57c03e5100d76e1482/7fc1e/prep-501.png 288w", "/learninghub/static/dca987c0fcae5f57c03e5100d76e1482/a5df1/prep-501.png 576w", "/learninghub/static/dca987c0fcae5f57c03e5100d76e1482/6a1d1/prep-501.png 1073w"],
          "sizes": "(max-width: 1073px) 100vw, 1073px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.3 In the menu on the top left, open the `}<strong parentName="p">{`Design`}</strong>{` folder (1) and select `}<strong parentName="p">{`Integrations`}</strong>{` (2). `}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "36.45833333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAYAAAAIy204AAAACXBIWXMAABJ0AAASdAHeZh94AAABYElEQVQoz42RS07DMBiEcwAqldI0j7oh7zgvu2krWlHxrEQFLBBbxAKOwim4DWtuNYyDukUsRp78+f3Z89vq5nMURYGSCilbCDiTCWzb/pcc18MsCOG6ApcXO1hxliEjyItj3FBr18XY8+Bxdf+Qxx7fFzgVUxRhgJJ7ExHBegwCXPk+2sEA78Mhdicn8PkzS1PEpilJeh18auqJ8SmyJEJYbiHUM2b6CaK6hXXuONhOp1CM+UrY/XiMqKqg2xZd16Hl2jRN75VSv55jUrqDrmI0Dx8o376RvXxB7D9h3fF21wSuCdqPRtCci+SmBQGbzaYHaa17v1ou6RXONmsslqu+vloorLRE1+aoZQIrMFHyHD4f44iwY9644HfG2ZZl2T+YiWm8lBIpY+dNhVxWrJsRZEhS9ucFopjAGUGmKQrD/iEmhJpYFWPXdd1DDPxQM16qBrKqkdPnPNzIHGxm/APuwMng7h+T+AAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep 44",
          "title": "prep 44",
          "src": "/learninghub/static/4601b9d4369d35ddfbacdfbc81737b26/3cbba/prep-44.png",
          "srcSet": ["/learninghub/static/4601b9d4369d35ddfbacdfbc81737b26/7fc1e/prep-44.png 288w", "/learninghub/static/4601b9d4369d35ddfbacdfbc81737b26/a5df1/prep-44.png 576w", "/learninghub/static/4601b9d4369d35ddfbacdfbc81737b26/3cbba/prep-44.png 1152w", "/learninghub/static/4601b9d4369d35ddfbacdfbc81737b26/50a82/prep-44.png 1411w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.4 Click on the `}<strong parentName="p">{`ace-designer-demo`}</strong>{` entry. `}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "31.944444444444443%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABJ0AAASdAHeZh94AAABHklEQVQY042RTU7DMBCFc4smjZofx39J7MRx0qppESAkxAIhxL4n4Q6ciRXneowjiCpWLJ7mfR7NjGYctW0LpRS01qh1jTzPsdls/q0kSamGIduVOJ/uESVJsjQJKoqCYoE4jteCa3/NcZxgG5qlW+iyIJXgGUckhEDvHFhVgdFjSarI/4ox9od/POfgFUPe3GLXvSJzb0jFEVHTGng/wNDqxhoMw4Cu62CMgbV24RADd7bDQMODN8bCO4ovH1CXT/DLF9Kbd0QPdY1n5/FoHZ6aFqfDAdN+D9f3cFQ8zzPGcURP7CePA7FzA4nYj5i8hTMcY6+geIFoT7e7kxpnLjHT/Rr6HCnlumI4SdDCgtZccnzNcy4glYaQChn1+gbswq8xoE6OcQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep 44 2",
          "title": "prep 44 2",
          "src": "/learninghub/static/1f1f50af7df639fd48c6c2780046eca7/3cbba/prep-44-2.png",
          "srcSet": ["/learninghub/static/1f1f50af7df639fd48c6c2780046eca7/7fc1e/prep-44-2.png 288w", "/learninghub/static/1f1f50af7df639fd48c6c2780046eca7/a5df1/prep-44-2.png 576w", "/learninghub/static/1f1f50af7df639fd48c6c2780046eca7/3cbba/prep-44-2.png 1152w", "/learninghub/static/1f1f50af7df639fd48c6c2780046eca7/152d6/prep-44-2.png 1422w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.5 Click the `}<strong parentName="p">{`Catalog`}</strong>{` icon to see a list of the available connectors. `}<br /><img src="images/prep-45.png" width="800" /><br /></p>
    <p>{`8.6 Search for `}<strong parentName="p">{`salesforce`}</strong>{` (1) and click `}<strong parentName="p">{`Connect`}</strong>{` (2).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "38.888888888888886%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAYAAAD5nd/tAAAACXBIWXMAABYlAAAWJQFJUiTwAAABV0lEQVQoz5WQzU7CQBSF+2oWVmgsb+ACdyaEjUo0MeEB2LIibli4dO+aGBKFEIiGnwZiIkWghdrOtAXaOU4H0ImGhSc5yZl7J3e+uYqmaUin00ilUlBVFYlEQjiZTG4s5z1W1QMcHh3j5PQMSrlchuM4sCwLtm2LTAiBF5tSeOs1PM/7Of923NvadV0o2WwWsUzThO/7+KPZDP+RcnV9I8KKk0RhCMaz025j9vyEeb0BI5+HVa3Cfn3BotWC1WwKzxsNkOEQEb/PogiMMWHl/OJSDIy2xVhGR4f+WINZr8EdDEB7PdBOB7Tb5c2xoCa6Dm80Evd3wwRhLpcTIYzp4iJ3wM9T4sBcfMD1A5AggLNcgvL9PlQquCsWMeG02NHJX5YHQnppMh6jx8n0fh9v/GuT6RSfhoH7Ugm3mQzeC4XNwC3IXsJdw18x0CDiqwi/a7KYtCK5/wUE4TGUsfqhjwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep4 5",
          "title": "Prep4 5",
          "src": "/learninghub/static/3611235e0d033c34c4801d049afb28f2/3cbba/Prep4.5.png",
          "srcSet": ["/learninghub/static/3611235e0d033c34c4801d049afb28f2/7fc1e/Prep4.5.png 288w", "/learninghub/static/3611235e0d033c34c4801d049afb28f2/a5df1/Prep4.5.png 576w", "/learninghub/static/3611235e0d033c34c4801d049afb28f2/3cbba/Prep4.5.png 1152w", "/learninghub/static/3611235e0d033c34c4801d049afb28f2/0b124/Prep4.5.png 1728w", "/learninghub/static/3611235e0d033c34c4801d049afb28f2/4ea69/Prep4.5.png 2304w", "/learninghub/static/3611235e0d033c34c4801d049afb28f2/d9e46/Prep4.5.png 2520w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.7 Input your Salesforce `}<strong parentName="p">{`Username`}</strong>{` (1). Fill in the connector’s `}<strong parentName="p">{`Password`}</strong>{` field (2) by concatenating your Salesforce `}<strong parentName="p">{`Password`}</strong>{` and the `}<strong parentName="p">{`Security token`}</strong>{` received via email.`}<br /><br />{`For example, if your Salesforce password is ‘myGreatPassword’ and your Salesforce security token is ‘2325jsdhew4312hs534dh’ then enter ‘myGreatPassword2325jsdhew4312hs534dh’ in the `}<strong parentName="p">{`Password`}</strong>{` field.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "59.02777777777778%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAMCAYAAABiDJ37AAAACXBIWXMAABYlAAAWJQFJUiTwAAABlUlEQVQoz6VS207CQBDlA4EEHwjf4JMxJuqP+Wa8BCTRqJEApbZFUmmtFgq90RvtcXZhExWvcZKTmc1kzpyZ2VK9Xkej0UClUkG5XOa+Wq3+Gds7+6jVtlDSdR1BEMD3fSwWCyRJgjRNObIs+zXiOILneSgZhoEoijCbzfBfYzwl0zT4Y7lcoigK5OQDz6VkTGpT6hxz1cILsHee57yGgVkYhiuFzFiSd8lyaFMfc8eiwoga5TTS5+MLQmFsZaTQfENICinvxSmc6YTvlRV+ZUKdIN0gFImcFDmOgznt1adFh3Q0BhYH1IT5iIrFVD8SMk0zKvJpJy4RMXgU+1QQ0OIZIvoFxYrtZ8LEsmB1u7BlGS+DAZ4liXt3OIQ3GnG4moZkMvlGIV2XX9u28Xx4AOPmGna/B1dVEAw1+JoKj4He3Cv3CDt3m4RvrywS9nkTytEx9JMmHk9bGJ9dwDxvv4PeuoKxu4dMVcWFVoQWjfeR0JUVDG970DsSRnd9jLsyTEmF2Vc4nii25AfY7UsU2XqX64/9Coz6dBUmoccmAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep4 7",
          "title": "Prep4 7",
          "src": "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/3cbba/Prep4.7.png",
          "srcSet": ["/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/7fc1e/Prep4.7.png 288w", "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/a5df1/Prep4.7.png 576w", "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/3cbba/Prep4.7.png 1152w", "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/0b124/Prep4.7.png 1728w", "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/4ea69/Prep4.7.png 2304w", "/learninghub/static/41661dc5db9f7cc5af226bd5b12fce5e/dd9cb/Prep4.7.png 2516w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.8 Input Salesforce’s `}<strong parentName="p">{`Consumer Key`}</strong>{` as `}<strong parentName="p">{`Client ID`}</strong>{` (1) and `}<strong parentName="p">{`Secret`}</strong>{` as `}<strong parentName="p">{`Client Secret`}</strong>{` (2), respectively, in the connector account UI. Click `}<strong parentName="p">{`Connect`}</strong>{` (3).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "29.51388888888889%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAABYlAAAWJQFJUiTwAAABS0lEQVQY022PS0sCURzF55NpiakIougioiD6Au3EjS0KEtq4r41fQhBBfCVaMYmJIZLvRm0Gm4fNjOI8TncmLCEP/Pgf7v3fw7lUKBRCOByG3++H2+3GAcETCMDr88HrcMDrdO7EY925XPaea38PRydnODw+BZVKpaAoCiRJwtdiAVnTIDca4DIZfI7H4Hs98P3+P4ThAEKnA5UXsFqvsVwuIcsyqGg0CkumaWKjVT6PUSIBplbDtFDExCJfsP2sVMakSGb5Hhw5M0mRbVGXV9e20TQdhq7bXsnl8HaTRPfxBaNqHdPnFphmBwO6hWGFxuSpCYbwXnqALoqwqpiGAYNAxeMXdohOwjYtTW0NdsRgPmUxe22jns2ifXuHeToNURAhfbCQWA6qINhBG1nvqVgs9he49XVV+1nqVqo4j0SQDAah0jR26bcImd/X/pB0SRtR6gAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Prep4 8",
          "title": "Prep4 8",
          "src": "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/3cbba/Prep4.8.png",
          "srcSet": ["/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/7fc1e/Prep4.8.png 288w", "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/a5df1/Prep4.8.png 576w", "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/3cbba/Prep4.8.png 1152w", "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/0b124/Prep4.8.png 1728w", "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/4ea69/Prep4.8.png 2304w", "/learninghub/static/960f4ced7cfbbae8508fb198c9c727cc/b8a32/Prep4.8.png 2522w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.9 Search for `}<strong parentName="p">{`insightly`}</strong>{` and click `}<strong parentName="p">{`Connect`}</strong>{`.`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "52.083333333333336%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAABYlAAAWJQFJUiTwAAABpklEQVQoz6VSPU8CQRC9f0AlEI0Ndja2/hXClxZa0lFgYmehDYm2/gZNsPKMCqiNjZVfB0bQg2MNCoLC3h1395y9y2H8LtzkJTvZmTfvzayUTqeRyWSQzWYh7tFoFLFYDPF4HMlkEqlU6k8kEkksLa9gYWERUi6XA2MMtm27+M8R9VIgEICiKBjoBq4qt6ipDY/YcWBZFmwBisX9O/jvDuUbhgEpEplCuVwedTAIr5zDpARxLO/hV2WOn0vk0vTMLG4qHqFDhe1aHeWzCzSUKtr3DM+ahtbGOronx+DtJ/CmBs6a4A8MA1WF2en4rJ7l8YlJ17LbwTTxSIV3ezJYsYCHo5KLuixDOzwAK5UIRTQLBWjFIhryLnpXlyMxLmEwODYitIX0oQmzy1CvyeB676u9z/Fw+HEpoVDonVDMSiyA99BSj9HrkkXdxGDAXbz0+661s508NtdWsT8/B+v8/LPC4Ltly10BbUuHcn2KSrVKUHHXaOJeY6iqGo1liNPtLazTv83TbH2Fjj/DcDj8USGZEs6fSUz31YBOX8Fv5Fl2ftyyqH8DLADEG5M8CJ8AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image5 6",
          "title": "prep image5 6",
          "src": "/learninghub/static/e6295cdd3ab64a91629daf8481367476/3cbba/prep-image5.6.png",
          "srcSet": ["/learninghub/static/e6295cdd3ab64a91629daf8481367476/7fc1e/prep-image5.6.png 288w", "/learninghub/static/e6295cdd3ab64a91629daf8481367476/a5df1/prep-image5.6.png 576w", "/learninghub/static/e6295cdd3ab64a91629daf8481367476/3cbba/prep-image5.6.png 1152w", "/learninghub/static/e6295cdd3ab64a91629daf8481367476/0b124/prep-image5.6.png 1728w", "/learninghub/static/e6295cdd3ab64a91629daf8481367476/d7c9e/prep-image5.6.png 2054w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`8.10 Paste your `}<strong parentName="p">{`API key`}</strong>{` (1) in the `}<strong parentName="p">{`API key`}</strong>{` field. Keep `}<strong parentName="p">{`v3.1`}</strong>{` (2) in the `}<strong parentName="p">{`API version`}</strong>{` field. Click `}<strong parentName="p">{`Connect`}</strong>{` (3).`}<br /><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "67.70833333333333%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAABYlAAAWJQFJUiTwAAACKklEQVQ4y51Ty44SQRTlY+SRqAkkLvgNZ+WaT5gdW1fERElYzM7E3ThfIHGhGUNgJiNOtGGgeTWPBhoGaOiH1U0/jrdbaDEDmHiTk+qbqnv61L2nQolEAslkEvF4HOFwGJFIxEc0Gv0nYrEY1Tyi2mc4eZHCk6ePEarVahgMBmg0GuB5Hq1WE+12m9BCr9dFt9uFIAiH0RXQozOdjoAm1YbS6TRyuRxM04QXy5UCTdPxP8F+MoSy2Szy+TwMg4GZNtr9CURphaVqQVF16LoOxpgPwzAewHEcH17IsoxQpcL5ieO6sC0LpqZAV0Yw2BLrteUrPwaX6rZh2zZC11dXvxPvL9YaUGWM2h8xG1c2x/4UwCvewk/dAAFhsVgMEn9zQ2F5oNzZEu0Jd4c4ICyVSkHib5oG5vU6Fg0ec76BFU189SoDrVyGKY1h9PtgnQ4cRflL5UOFluWv1niEwe13DNsdzHp9TMgOIlfBnL5lcYilNMG8L2JR52Fv1B+8sr9Pkxt/LYP//AX1T5doXhYg3pQxuL7xV7FQhPD6Dd2CD0QcVWhPp5A4DlO6liaKUMn0GkEXB2ATCTqZeX7xHgq1QqeHsDu2vQpt8pJ0+w0j7gfu6RV5ZGw4xKLbg1S9I1QxIdLZXRUqkR5WuJmyF5piQFnqUO4X+HB2hneZDLjzc7iqCkYwaSAOGd3dGPpoD70my/TyVLKkrjK8PT3Fy1QKhZPnALVjn3V2CX8BQtry6en4yCoAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "prep image5 7",
          "title": "prep image5 7",
          "src": "/learninghub/static/bac02af9efa76296005d2e353cabdaac/3cbba/prep-image5.7.png",
          "srcSet": ["/learninghub/static/bac02af9efa76296005d2e353cabdaac/7fc1e/prep-image5.7.png 288w", "/learninghub/static/bac02af9efa76296005d2e353cabdaac/a5df1/prep-image5.7.png 576w", "/learninghub/static/bac02af9efa76296005d2e353cabdaac/3cbba/prep-image5.7.png 1152w", "/learninghub/static/bac02af9efa76296005d2e353cabdaac/0b124/prep-image5.7.png 1728w", "/learninghub/static/bac02af9efa76296005d2e353cabdaac/93955/prep-image5.7.png 2056w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span><br /></p>
    <p>{`Your environment is ready to demo.`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      